import './FieldService.css';
import './EquipmentStyles.css';
import { useState, useEffect,useContext } from 'react';
import FieldServiceAPI from '../Services/FieldService';
import {Context} from '../Context';

const calendarHelpLink = 'https://cornerstonedetentionproducts.box.com/s/ld6636ryxqkwzkit1az46tza9o58zupl';
const fsrHelpLink = 'https://cornerstonedetentionproducts.box.com/s/8g7p89j8lrlffavw66jet2y02ojwfthx';
const equipmentMangementHelpLink = 'https://cornerstonedetentionproducts.box.com/s/qgcnwa949l9e0vd4h78y5dipbqri0yor';

const branchOptions = [
    { value: 'complete', label: 'All Branches' },
    { value: '12', label: 'Greenville, WI' },
    { value: '61', label: 'Garner, NC' },
    { value: '62', label: 'Chandler, AZ' },
    { value: '64', label: 'Hartselle, AL' },
    { value: '66', label: 'San Antonio, TX' },
];

const moduleOptions = [
    { value: 'Calendar', label: 'Calendar' },
    { value: 'Reports', label: 'Reports' },
    { value: 'Equipment', label: 'Equipment' },
];

const appointmentTypeOptions = [
    { value: 'SC', label: 'Service Call' },
    { value: 'INST', label: 'Daily Log' },
    { value: 'PM', label: 'Preventative Maintenance' },
    { value: 'WHLSL', label: 'Wholesale' },
    { value: 'WAR', label: 'Warranty' },
];

const equipmentTypeOptions = [
    'CCTV Headend','Camera','CCTV Misc','Server','Computer','PLC','Switch','Graphics Panel','Access Control','Audio','Building Control','Duress Alarm','Perimeter','Fire Alarm','Door','Frame','Partition','Sliding Hardware','Swing Hardware','DPS','Misc Hardware','Furniture','Glass','Plumbing','Electrical','HVAC','Other'
];

const getNormalizedAppointmentStatus = (status) => (status == null ? 'Not Confirmed' : status);

const getAppointmentStatusClassName = (status) => getNormalizedAppointmentStatus(status).toLowerCase().replace(/\s+/g, '-');

// API Call Functions
const getAllServiceTechnicians = async (token, setTo, setError) => {
    const response = await FieldServiceAPI.getServiceTechnicians(token);
    if(response.status === 200){
        console.log('Service Technicians fetched:', response.data);
        setTo(response.data);
    } else {
        console.log('Error fetching service technicians:', response);
        setError(response.message || 'Error fetching service technicians');
    }
};

const getAllAppointments = async (token, branch, setTo, setError) => {
    const response = await FieldServiceAPI.getAppointments(token, branch);
    if(response.status === 200){
        console.log('Appointments fetched:', response.data);
        setTo(response.data);
    } else {
        console.log('Error fetching appointments:', response);
        setError(response.message || 'Error fetching appointments');
    };
};

const getAllCustomers = async (token, setTo, setError, setLoading) => {
    setLoading(true);
    const response = await FieldServiceAPI.getAllCustomers(token);
    if(response.status === 200){
        console.log('Customers fetched:', response.data);
        setTo(response.data);
    } else {
        console.log('Error fetching customers:', response);
        setError(response.message || 'Error fetching customers');
    };
    setLoading(false);
};

const getCustomerLocations = async (token, customerId, setTo, setError) => {
    const response = await FieldServiceAPI.getCustomerLocations(token, customerId);
    if(response.status === 200){
        console.log('Customer locations fetched:', response.data);
        setTo(response.data);
    } else {
        console.log('Error fetching customer locations:', response);
        setError(response.message || 'Error fetching customer locations');
    };
};

const fetchCustomerAndLocations = async (apiToken, setCustomerAndLocations, setError) => {
    try {
        const response = await FieldServiceAPI.getCustomersAndLocations(apiToken);
        if (response.status > 199 && response.status < 300) setCustomerAndLocations(response.data);
        else setError('Error fetching customers and locations');
    } catch (error) {
        console.error(error);
        setError('Error fetching customers and locations');
    };
};

const getPreviousAppointments = async (token, customerId, locationId, setTo, setError) => {
    const response = await FieldServiceAPI.getPreviousAppointments(token, customerId, locationId);
    if(response.status === 200){
        console.log('Previous appointments fetched:', response.data);
        setTo(response.data.previousWork || []);
    } else {
        console.log('Error fetching previous appointments:', response);
        setError(response.message || 'Error fetching previous appointments');
    };
};

const createFSAppointment = async (token, appointmentObject, setSuccess, setError) => {
    const response = await FieldServiceAPI.createAppointment(token, appointmentObject);
    if(response.status > 199 && response.status < 300){
        setSuccess('Appointment created successfully');
    } else {
        console.log('Error creating appointment:', response);
        setError(response.message || 'Error creating appointment');
    }
};

const updateFSAppointment = async (token, appointmentObject, setSuccess, setError) => {
    const response = await FieldServiceAPI.updateAppointment(token, appointmentObject);
    if(response.status > 199 && response.status < 300){
        setSuccess('Appointment updated successfully');
    } else {
        console.log('Error updating appointment:', response);
        setError(response.message || 'Error updating appointment');
    };
};

const changeFSAppointmentDate = async (token, appointmentId, newStartDate, setSuccess, setError) => {
    const response = await FieldServiceAPI.changeAppointmentDate(token, appointmentId, newStartDate);
    if(response.status > 199 && response.status < 300){
        setSuccess('Appointment date changed successfully');
    } else {
        console.log('Error changing appointment date:', response);
        setError(response.message || 'Error changing appointment date');
    };
};


const deleteFSAppointment = async (token, appointmentId, setSuccess, setError) => {
    const response = await FieldServiceAPI.deleteAppointment(token, appointmentId);
    if(response.status > 199 && response.status < 300){
        setSuccess('Appointment deleted successfully');
    } else {
        console.log('Error deleting appointment:', response);
        setError(response.message || 'Error deleting appointment');
    };
};

const getCompletedFSR = async (token, filename) => {
    const response = await FieldServiceAPI.getCompletedFSRFile(token, filename);
    if(response.status === 200){
        console.log('Completed FSR fetched:', response.data);
        return response.data;
    } else {
        console.log('Error fetching completed FSR:', response);
        throw new Error(response.message || 'Error fetching completed FSR');
    };
};

const recreateFSR = async (token, appointmentId) => {
    const response = await FieldServiceAPI.recreateFSR(token, appointmentId);
    if (response.status > 199 && response.status < 300) {
        console.log('FSR recreated successfully:', response.data);
        const responseData = response.data || {};
        return responseData.fsr || responseData.fsrURL || null; // Return the FSR URL or download URL if available 
    }

    console.log('Error recreating FSR:', response);
    throw new Error(response?.data?.message || response?.message || 'Error recreating FSR');
};

const fetchAttachment = async (token, filename) => {
    const response = await FieldServiceAPI.getAttachmentFile(token, filename);
    if(response.status === 200){
        console.log('Attachment fetched:', response.data);
        return response.data;
    } else {
        console.log('Error fetching attachment:', response);
        throw new Error(response.message || 'Error fetching attachment');
    };
};

const getAppointmentById = async (token, appointmentId, setTo, setError) => {
    const response = await FieldServiceAPI.getAppointmentById(token, appointmentId);
    if(response.status > 199 && response.status < 300){
        console.log('Appointment fetched by ID:', response.data);
        setTo(response.data);
    } else {
        console.log('Error fetching appointment by ID:', response);
        setError(response.message || 'Error fetching appointment by ID');
    };
};

const getPastAppointments = async (token, filterObject, setTo, setError) => {
    const response = await FieldServiceAPI.getHistoricAppointments(token, filterObject);
    if(response.status > 199 && response.status < 300){
        console.log('Past appointments fetched:', response.data);
        setTo(response.data);
    } else {
        console.log('Error fetching past appointments:', response);
        setError(response.message || 'Error fetching past appointments');
    };
};

const getCustomerLocationEquipment = async (token, customerId, locationId, setTo, setError) => {
    const response = await FieldServiceAPI.getCustomerLocationEquipment(token, customerId, locationId);
    if(response.status > 199 && response.status < 300){
        console.log('Customer location equipment fetched:', response.data);
        setTo(response.data);
    } else {
        console.log('Error fetching customer location equipment:', response);
        setError(response.message || 'Error fetching customer location equipment');
    };
};

const getAllEquipment = async (token, filterObject, setTo, setError) => {
    const response = await FieldServiceAPI.getAllEquipmentRecords(token, filterObject);
    if(response.status > 199 && response.status < 300){
        console.log('Equipment records fetched:', response.data);
        setTo(response.data);
    } else {
        console.log('Error fetching equipment records:', response);
        setError(response.message || 'Error fetching equipment records');
    };
};

const createEquipmentRecord = async (token, equipmentObject, setSuccess, setError) => {
    const response = await FieldServiceAPI.createEquipmentRecord(token, equipmentObject);
    if(response.status > 199 && response.status < 300){
        setSuccess('Equipment record created successfully');
    } else {
        console.log('Error creating equipment record:', response);
        setError(response.message || 'Error creating equipment record');
    };
};

const updateEquipmentRecord = async (token, equipmentObject, setSuccess, setError) => {
    const response = await FieldServiceAPI.updateEquipmentRecord(token, equipmentObject);
    if(response.status > 199 && response.status < 300){
        setSuccess('Equipment record updated successfully');
    } else {
        console.log('Error updating equipment record:', response);
        setError(response.message || 'Error updating equipment record');
    };
};

const deleteEquipmentRecord = async (token, recordId, setSuccess, setError) => {
    const response = await FieldServiceAPI.deleteEquipmentRecord(token, recordId);
    if(response.status > 199 && response.status < 300){
        setSuccess('Equipment record deleted successfully');
    } else {
        console.log('Error deleting equipment record:', response);
        setError(response.message || 'Error deleting equipment record');
    };
};

// Components
const FieldServiceHeader = ({moduleSelected, changeModule, branchSelected,  setBranchSelected, createAppointment, createFSR, createEquipment, isCreatingEquipment, isEditingEquipment, isEquipmentFormValid, equipmentLoading, handleEquipmentSubmit, handleEquipmentCancel, handleEquipmentDelete, selectedEquipment, handleEquipmentEdit, handleEquipmentClose, refreshModuleResults}) => {

    const getHelpLinkForModule = (moduleName) => {
        if (moduleName === 'Calendar') return calendarHelpLink;
        if (moduleName === 'FSR') return fsrHelpLink;
        if (moduleName === 'Equipment') return equipmentMangementHelpLink;
        return '';
    };

    const handleOpenModuleHelp = () => {
        const moduleHelpLink = getHelpLinkForModule(moduleSelected);
        if (!moduleHelpLink) return;
        window.open(moduleHelpLink, '_blank', 'noopener,noreferrer');
    };

    const BranchSelector = () => {
        return (
            <div className="field-service-branch-selector">
                <select 
                    className="field-service-branch-select-input"
                    value={branchSelected} 
                    onChange={(e) => setBranchSelected(e.target.value)}
                >
                    {branchOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>
        );
    };

    const ModuleSelector = () => {
        return (
            <div className="field-service-module-selection">
                <div className="field-service-module-input-container">
                    <select 
                        className="field-service-module-select-input"
                        value={moduleSelected} 
                        onChange={(e) => changeModule(e.target.value)}
                    >
                        {moduleOptions.map((option) => (
                            <option key={option.value} value={option.value}>   
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        );
    };

    const HeaderContent = () => {
        const moduleHelpLink = getHelpLinkForModule(moduleSelected);

        return (
            <div className="field-service-header-content">
                <div className="field-service-branch-selection">
                    <BranchSelector />
                </div>
                
                <div className="field-service-header-actions">
                    {moduleSelected === 'Calendar' && (
                        <button 
                            className="field-service-nav-button primary"
                            onClick={() => createAppointment()}
                        >
                            + New Appointment
                        </button>
                    )}

                    {moduleSelected === 'FSR' && (
                        <>
                        </>
                    )}

                    {moduleSelected === 'Equipment' && (
                        <>
                            {(isCreatingEquipment || isEditingEquipment) ? (
                                <>
                                    <button 
                                        className="field-service-nav-button primary"
                                        onClick={handleEquipmentCancel}
                                        disabled={equipmentLoading}
                                    >
                                        Cancel
                                    </button>
                                    {isEditingEquipment && (
                                        <button 
                                            className="field-service-nav-button danger"
                                            onClick={handleEquipmentDelete}
                                            disabled={equipmentLoading}
                                        >
                                            Delete
                                        </button>
                                    )}
                                    <button 
                                        className="field-service-nav-button primary"
                                        onClick={handleEquipmentSubmit}
                                        disabled={!isEquipmentFormValid || equipmentLoading}
                                    >
                                        {equipmentLoading ? 'Saving...' : isCreatingEquipment ? 'Create New Equipment' : 'Update'}
                                    </button>
                                </>
                            ) : selectedEquipment ? (
                                <>
                                    <button 
                                        className="field-service-nav-button primary"
                                        onClick={handleEquipmentClose}
                                    >
                                        Close
                                    </button>
                                    <button 
                                        className="field-service-nav-button primary"
                                        onClick={handleEquipmentEdit}
                                    >
                                        Edit Equipment
                                    </button>
                                </>
                            ) : (
                                <button 
                                    className="field-service-nav-button primary"
                                    onClick={() => createEquipment()}
                                >
                                    + New Equipment
                                </button>
                            )}
                        </>
                    )}

                    <button
                        className="field-service-refresh-btn"
                        onClick={refreshModuleResults}
                        title="Refresh current module"
                    >
                        ↻
                    </button>
                    <button
                        className="field-service-nav-button secondary"
                        onClick={handleOpenModuleHelp}
                        disabled={!moduleHelpLink}
                        title={moduleHelpLink ? 'Open module help' : 'Help link not configured'}
                    >
                        ?
                    </button>
                </div>
            </div>
        );
    };

    return (
        <div className="field-service-header">
            <ModuleSelector />
            <HeaderContent />
        </div>
    );
};

const AppointmentBody = ({ 
    startDate, setStartDate,
    endDate, setEndDate,
    startTime, setStartTime,
    endTime, setEndTime,
    type, setType,
    customer, setCustomer,
    project, setProject,
    location, setLocation,
    address, setAddress,
    address2, setAddress2,
    city, setCity,
    state, setState,
    zip, setZip,
    country, setCountry,
    contact, setContact,
    title, setTitle,
    phone, setPhone,
    email, setEmail,
    assignedTo, setAssignedTo,
    requireFSR, setRequireFSR,
    autosendFSR, setAutosendFSR,
    notes, setNotes,
    onClose, 
    notifyTechs, setNotifyTechs,
    multipleFSRs, setMultipleFSRs,
    pmChecklist, setPmChecklist,
    fileShareLink, setFileShareLink,
    createAppointmentObject,
    deleteAppointment,
    customerSearch, setCustomerSearch,
    filteredCustomers,
    selectedCustomer, setSelectedCustomer,
    customerLocationSearch, setCustomerLocationSearch,
    filteredLocations,
    selectedLocation, setSelectedLocation,
    projectsSearch, setProjectsSearch,
    filteredProjects,
    selectedProject, setSelectedProject,
    technicianSearch, setTechnicianSearch,
    searchFilteredTechnicians,
    selectedTechnicians, setSelectedTechnicians,
    overrideAddress, setOverrideAddress,
    overrideContact, setOverrideContact,
    createNewLocation, setCreateNewLocation,
    createNewContact, setCreateNewContact,
    appointmentDescription, setAppointmentDescription,
    token,
    customers,
    customersLoading,
    projectsLoading,
    setCustomerLocations,
    setCustomerLocationsError,
    createNewLocationToggle, setCreateNewLocationToggle,
    appointmentType,
    showCustomerDropdown, setShowCustomerDropdown,
    showLocationDropdown,setShowLocationDropdown,
    showTechnicianDropdown,setShowTechnicianDropdown,
    showContactDropdown, setShowContactDropdown,
    contactSearch, setContactSearch,
    filteredContacts,
    selectedContact, setSelectedContact,
    relatedAppointment, setRelatedAppointment,
    existingAppointmentObject,
    previousAppointments,
    showPreviousAppointmentsDropdown, setShowPreviousAppointmentsDropdown,
    previousAppointmentSearch, setPreviousAppointmentSearch,
    filteredPreviousAppointments,
    selectedPreviousAppointment, setSelectedPreviousAppointment,
    creatingNewCustomer, setCreatingNewCustomer,
    newCustomerNumber, setNewCustomerNumber,
    newCustomerName, setNewCustomerName,
    newCustomerClass, setNewCustomerClass,
    isReadOnly = false
}) => {

    // Handle override states when location selection changes
    useEffect(() => {
        if (!selectedLocation) {
            // When no location is selected, enable address and contact inputs by default
            setOverrideAddress(true);
            setOverrideContact(true);
            // Clear create new flags when no location is selected
            setCreateNewLocation(false);
            setCreateNewContact(false);
        }
        // When a location is selected, the override states are set to false in the location selection handler
    }, [selectedLocation, setOverrideAddress, setOverrideContact, setCreateNewLocation, setCreateNewContact]);

    // Handle project selection - populate address and set customer/location
    useEffect(() => {
        if (selectedProject && token) {
            // Populate address fields from project
            if (selectedProject.address && typeof selectedProject.address === 'object') {
                setAddress(selectedProject.address.addressLine1 || '');
                setAddress2(selectedProject.address.addressLine2 || '');
                setCity(selectedProject.address.city || '');
                setState(selectedProject.address.state || '');
                setZip(selectedProject.address.postalCode || '');
            }

            // Find and set the customer based on customerID
            const projectCustomer = customers.find(customer => customer.customerNumber === selectedProject.customerID);
            if (projectCustomer) {
                setSelectedCustomer(projectCustomer);
                setCustomer(projectCustomer.customerName);
                setCustomerSearch('');

                // Fetch customer locations and then set the project location
                getCustomerLocations(token, projectCustomer.id, 
                    (locations) => {
                        setCustomerLocations(locations);
                        // Find and set the location based on project location
                        const projectLocation = locations.find(location => location.locationID === selectedProject.location);
                        if (projectLocation) {
                            setSelectedLocation(projectLocation);
                            setLocation(projectLocation.locationName);
                            setCustomerLocationSearch('');
                            
                            // Set override flags to false since we're using project/location data
                            setOverrideAddress(false);
                            setOverrideContact(false);
                            
                            // Populate contact fields if available from location
                            if (projectLocation.contact && typeof projectLocation.contact === 'object') {
                                setContact(projectLocation.contact.name || projectLocation.contact.contactName || '');
                                if (projectLocation.contact.phone) {
                                    setPhone(projectLocation.contact.phone);
                                }
                                if (projectLocation.contact.email) {
                                    setEmail(projectLocation.contact.email);
                                }
                                if (projectLocation.contact.title) {
                                    setTitle(projectLocation.contact.title);
                                }
                            }
                        }
                    },
                    setCustomerLocationsError
                );
            }
        }
    }, [selectedProject, customers, token]);

    // State for date/time validation error styling
    const [dateTimeError, setDateTimeError] = useState(false);
    const [errorTimeout, setErrorTimeout] = useState(null);
    const [notification, setNotification] = useState(null);
    const [notificationTimeout, setNotificationTimeout] = useState(null);

    // Function to show notification
    const showNotification = (message, type = 'warning') => {
        setNotification({ message, type });
        
        // Clear any existing notification timeout
        if (notificationTimeout) {
            clearTimeout(notificationTimeout);
        }

        // Set timeout to hide notification after 10 seconds
        const timeout = setTimeout(() => {
            setNotification(null);
            setNotificationTimeout(null);
        }, 10000);
        setNotificationTimeout(timeout);
    };

    // Function to validate and adjust end date/time
    const validateAndAdjustDateTime = (newStartDate, newStartTime, currentEndDate, currentEndTime) => {
        const startDateTime = new Date(`${newStartDate.toISOString().split('T')[0]}T${newStartTime}:00`);
        const endDateTime = new Date(`${currentEndDate.toISOString().split('T')[0]}T${currentEndTime}:00`);

        if (endDateTime <= startDateTime) {
            // Show error styling
            setDateTimeError(true);
            
            // Clear any existing timeout
            if (errorTimeout) {
                clearTimeout(errorTimeout);
            }

            // Set new timeout to remove error styling after 10 seconds
            const timeout = setTimeout(() => {
                setDateTimeError(false);
                setErrorTimeout(null);
            }, 10000);
            setErrorTimeout(timeout);

            // Automatically adjust end time to be 1 hour after start time
            const adjustedEndDateTime = new Date(startDateTime);
            adjustedEndDateTime.setHours(adjustedEndDateTime.getHours() + 1);
            
            // Handle day boundary crossing (e.g., 23:30 + 1 hour = next day at 00:30)
            const adjustedDate = new Date(adjustedEndDateTime.getFullYear(), adjustedEndDateTime.getMonth(), adjustedEndDateTime.getDate());
            const adjustedTime = adjustedEndDateTime.toTimeString().substring(0, 5); // Format as HH:MM
            
            // Update end date and time
            setEndDate(adjustedDate);
            setEndTime(adjustedTime);
            
            // Show notification to user
            showNotification('End date/time cannot be before start date/time. Automatically adjusted to 1 hour after start time.', 'warning');
            
            return true; // Indicates adjustment was made
        }
        return false; // No adjustment needed
    };

    // Enhanced setters for start date/time with validation
    const handleStartDateChange = (newDate) => {
        setStartDate(newDate);
        validateAndAdjustDateTime(newDate, startTime, endDate, endTime);
    };

    const handleStartTimeChange = (newTime) => {
        setStartTime(newTime);
        validateAndAdjustDateTime(startDate, newTime, endDate, endTime);
    };

    // Enhanced setters for end date/time with validation
    const handleEndDateChange = (newDate) => {
        const startDateTime = new Date(`${startDate.toISOString().split('T')[0]}T${startTime}:00`);
        const newEndDateTime = new Date(`${newDate.toISOString().split('T')[0]}T${endTime}:00`);
        
        if (newEndDateTime <= startDateTime) {
            // Show error styling
            setDateTimeError(true);
            
            // Clear any existing timeout
            if (errorTimeout) {
                clearTimeout(errorTimeout);
            }

            // Set new timeout to remove error styling after 10 seconds
            const timeout = setTimeout(() => {
                setDateTimeError(false);
                setErrorTimeout(null);
            }, 10000);
            setErrorTimeout(timeout);

            // Show notification
            showNotification('End date cannot be before or equal to start date/time. Please select a later date.', 'error');

            // Don't allow setting invalid end date, keep current
            return;
        }
        
        // Clear error state and notifications when valid date is set
        if (dateTimeError) {
            setDateTimeError(false);
            if (errorTimeout) {
                clearTimeout(errorTimeout);
                setErrorTimeout(null);
            }
        }
        if (notification) {
            setNotification(null);
            if (notificationTimeout) {
                clearTimeout(notificationTimeout);
                setNotificationTimeout(null);
            }
        }
        
        setEndDate(newDate);
    };

    const handleEndTimeChange = (newTime) => {
        const startDateTime = new Date(`${startDate.toISOString().split('T')[0]}T${startTime}:00`);
        const newEndDateTime = new Date(`${endDate.toISOString().split('T')[0]}T${newTime}:00`);
        
        if (newEndDateTime <= startDateTime) {
            // Show error styling
            setDateTimeError(true);
            
            // Clear any existing timeout
            if (errorTimeout) {
                clearTimeout(errorTimeout);
            }

            // Set new timeout to remove error styling after 10 seconds
            const timeout = setTimeout(() => {
                setDateTimeError(false);
                setErrorTimeout(null);
            }, 10000);
            setErrorTimeout(timeout);

            // Show notification
            showNotification('End time cannot be before or equal to start date/time. Please select a later time.', 'error');

            // Don't allow setting invalid end time, keep current
            return;
        }
        
        // Clear error state and notifications when valid time is set
        if (dateTimeError) {
            setDateTimeError(false);
            if (errorTimeout) {
                clearTimeout(errorTimeout);
                setErrorTimeout(null);
            }
        }
        if (notification) {
            setNotification(null);
            if (notificationTimeout) {
                clearTimeout(notificationTimeout);
                setNotificationTimeout(null);
            }
        }
        
        setEndTime(newTime);
    };

    // Cleanup timeouts on unmount
    useEffect(() => {
        return () => {
            if (errorTimeout) {
                clearTimeout(errorTimeout);
            }
            if (notificationTimeout) {
                clearTimeout(notificationTimeout);
            }
        };
    }, [errorTimeout, notificationTimeout]);

    const handleCancel = () => {
        onClose();
    };

    // Validation function to check if all required fields are filled
    const isFormValid = () => {
        // Basic Information requirements
        const hasBasicInfo = startDate && endDate && startTime && endTime && type;
        
        // Customer requirement
        const hasCustomer = selectedCustomer && selectedCustomer.customerNumber;
        
        // Location requirement (must have a valid location name)
        const hasLocation = selectedLocation || (customerLocationSearch && customerLocationSearch.trim());
        
        // Address requirements (all except address line 2)
        const hasRequiredAddress = address.trim() && city.trim() && state && zip.trim();
        
        // Contact requirements (name and email)
        const hasRequiredContact = contact.trim() && email.trim();
        
        // At least 1 assigned technician
        const hasAssignedTechnician = selectedTechnicians && selectedTechnicians.length > 0;
        
        // Appointment description requirement
        const hasAppointmentDescription = appointmentDescription.trim();
        
        return hasBasicInfo && hasCustomer && hasLocation && hasRequiredAddress && hasRequiredContact && hasAssignedTechnician && hasAppointmentDescription;
    };

    return (
        <div className="field-service-form">
            {/* Notification Toast */}
            {notification && (
                <div className={`field-service-notification ${notification.type}`}>
                    <div className="field-service-notification-content">
                        <span className="field-service-notification-icon">
                            {notification.type === 'warning' ? '⚠️' : notification.type === 'error' ? '❌' : 'ℹ️'}
                        </span>
                        <span className="field-service-notification-message">{notification.message}</span>
                        <button 
                            className="field-service-notification-close"
                            onClick={() => {
                                setNotification(null);
                                if (notificationTimeout) {
                                    clearTimeout(notificationTimeout);
                                    setNotificationTimeout(null);
                                }
                            }}
                        >
                            ×
                        </button>
                    </div>
                </div>
            )}
            
            <fieldset disabled={isReadOnly} className="field-service-read-only-fieldset">
            {/* Acumatica Appointment Section - Only show for Edit appointments */}
            {appointmentType === 'Edit' && existingAppointmentObject && (
                <div className="field-service-form-section">
                    <h4 className="field-service-form-section-title">Appointment Details</h4>
                    
                    <div className="field-service-form-row">
                        <div className="field-service-form-group">
                            <label className="field-service-form-label">Appointment ID</label>
                            <div className="field-service-appointment-info">
                                <span className="field-service-appointment-text">
                                    {existingAppointmentObject.appointmentID}
                                </span>
                            </div>
                        </div>
                        <div className="field-service-form-group">
                            <label className="field-service-form-label">Status</label>
                            <div className="field-service-appointment-info">
                                <span className={`field-service-appointment-status ${
                                    existingAppointmentObject.appointmentFinalized === true
                                        ? 'finalized'
                                        : `status-${getAppointmentStatusClassName(existingAppointmentObject.status)}`
                                }`}>
                                    {existingAppointmentObject.appointmentFinalized === true
                                        ? 'Finalized'
                                        : getNormalizedAppointmentStatus(existingAppointmentObject.status)}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="field-service-form-row">
                        <div className="field-service-form-group">
                            <label className="field-service-form-label">Created By</label>
                            <div className="field-service-appointment-info">
                                <span className="field-service-appointment-text">
                                    {existingAppointmentObject.createdBy || 'N/A'}
                                </span>
                            </div>
                        </div>
                        <div className="field-service-form-group">
                            <label className="field-service-form-label">Created Date</label>
                            <div className="field-service-appointment-info">
                                <span className="field-service-appointment-text">
                                    {existingAppointmentObject.createdDate 
                                        ? new Date(existingAppointmentObject.createdDate).toLocaleString() 
                                        : 'N/A'}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="field-service-form-row">
                        <div className="field-service-form-group">
                            <label className="field-service-form-label">FSR Complete</label>
                            <div className="field-service-appointment-info">
                                <span className={`field-service-appointment-status ${existingAppointmentObject.fsrComplete ? 'complete' : 'incomplete'}`}>
                                    {existingAppointmentObject.fsrComplete ? 'Complete' : 'Incomplete'}
                                </span>
                            </div>
                        </div>
                        <div className="field-service-form-group">
                            <label className="field-service-form-label">FSR Sent</label>
                            <div className="field-service-appointment-info">
                                <span className={`field-service-appointment-status ${existingAppointmentObject.fsrSent ? 'sent' : 'not-sent'}`}>
                                    {existingAppointmentObject.fsrSent ? 'Sent' : 'Not Sent'}
                                </span>
                            </div>
                        </div>
                    </div>

                    {existingAppointmentObject.fsrSent && existingAppointmentObject.fsrSentDate && (
                        <div className="field-service-form-row">
                            <div className="field-service-form-group">
                                <label className="field-service-form-label">FSR Sent Date</label>
                                <div className="field-service-appointment-info">
                                    <span className="field-service-appointment-text">
                                        {new Date(existingAppointmentObject.fsrSentDate).toLocaleString()}
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}

                    {existingAppointmentObject.appointmentLink && (
                        <div className="field-service-form-row">
                            <div className="field-service-form-group">
                                <label className="field-service-form-label">Appointment Link</label>
                                <div className="field-service-appointment-info" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <span className="field-service-appointment-text" style={{ 
                                        flex: 1, 
                                        overflow: 'hidden', 
                                        textOverflow: 'ellipsis', 
                                        whiteSpace: 'nowrap',
                                        fontSize: '13px'
                                    }}>
                                        {existingAppointmentObject.appointmentLink}
                                    </span>
                                    <button
                                        type="button"
                                        className="field-service-copy-button"
                                        onClick={() => {
                                            navigator.clipboard.writeText(existingAppointmentObject.appointmentLink);
                                            const button = document.activeElement;
                                            const originalText = button.textContent;
                                            button.textContent = 'Copied!';
                                            setTimeout(() => {
                                                button.textContent = originalText;
                                            }, 2000);
                                        }}
                                        style={{
                                            padding: '6px 12px',
                                            backgroundColor: 'var(--primary-color)',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            fontSize: '12px',
                                            whiteSpace: 'nowrap',
                                            transition: 'background-color 0.2s'
                                        }}
                                        onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--primary-color-hover)'}
                                        onMouseLeave={(e) => e.target.style.backgroundColor = 'var(--primary-color)'}
                                        title="Copy link to clipboard"
                                    >
                                        Copy Link
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
            
            {/* Basic Information Section */}
            <div className="field-service-form-section">
                <h4 className="field-service-form-section-title">📅 Basic Information</h4>
                
                <div className="field-service-form-row">
                    <div className="field-service-form-group">
                        <label className="field-service-form-label required">Start Date</label>
                        <input 
                            type="date" 
                            className="field-service-form-input"
                            value={startDate.toISOString().split('T')[0]}
                            onChange={(e) => handleStartDateChange(new Date(e.target.value))}
                        />
                    </div>
                    <div className="field-service-form-group">
                        <label className="field-service-form-label required">End Date</label>
                        <input 
                            type="date" 
                            className={`field-service-form-input ${dateTimeError ? 'field-service-datetime-error' : ''}`}
                            value={endDate.toISOString().split('T')[0]}
                            onChange={(e) => handleEndDateChange(new Date(e.target.value))}
                        />
                    </div>
                </div>

                <div className="field-service-form-row">
                    <div className="field-service-form-group">
                        <label className="field-service-form-label required">Start Time</label>
                        <input 
                            type="time" 
                            className="field-service-form-input"
                            value={startTime}
                            onChange={(e) => handleStartTimeChange(e.target.value)}
                        />
                    </div>
                    <div className="field-service-form-group">
                        <label className="field-service-form-label required">End Time</label>
                        <input 
                            type="time" 
                            className={`field-service-form-input ${dateTimeError ? 'field-service-datetime-error' : ''}`}
                            value={endTime}
                            onChange={(e) => handleEndTimeChange(e.target.value)}
                        />
                    </div>
                </div>

                <div className="field-service-form-row">
                    <div className="field-service-form-group">
                        <label className="field-service-form-label required">Type</label>
                        <select 
                            className="field-service-form-select"
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                        >
                            {appointmentTypeOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                    {appointmentType !== 'Edit' && startDate.toISOString().split('T')[0] !== endDate.toISOString().split('T')[0] && (
                        <div className="field-service-form-group">
                            <label className="field-service-form-label">FSR Type</label>
                            <div className="field-service-fsr-toggle">
                                <button
                                    type="button"
                                    className={`field-service-fsr-toggle-button ${multipleFSRs ? 'active' : ''}`}
                                    onClick={() => setMultipleFSRs(true)}
                                >
                                    Multiple FSRs
                                </button>
                                <button
                                    type="button"
                                    className={`field-service-fsr-toggle-button ${!multipleFSRs ? 'active' : ''}`}
                                    onClick={() => setMultipleFSRs(false)}
                                >
                                    Single FSR
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* Customer & Project Information */}
            <div className="field-service-form-section">
                <div className="field-service-form-section-header">
                    <h4 className="field-service-form-section-title">🏢 Customer & Project</h4>
                </div>

                {customersLoading && appointmentType === 'New' ? (
                    <div className="field-service-section-loading">
                        <div className="field-service-section-loading-animation">
                            <div className="field-service-section-spinner"></div>
                        </div>
                        <h4>Loading Customers<span className="field-service-section-loading-dots"></span></h4>
                        <p>Please wait while we retrieve the available customers for your selection.</p>
                    </div>
                ) : (
                    <>
                        {!creatingNewCustomer && (
                        <div className="field-service-form-row">
                                <div className="field-service-form-group">
                                    <label className="field-service-form-label required">Customer</label>
                        <div className="customer-search-container">
                            <input 
                                type="text" 
                                className="field-service-form-input"
                                placeholder="Enter customer name or ID"
                                value={selectedCustomer ? `${selectedCustomer.customerNumber} - ${selectedCustomer.customerName}` : customerSearch}
                                onChange={(e) => {
                                    if (appointmentType === 'Edit' && selectedCustomer) return;
                                    if (selectedCustomer) {
                                        setSelectedCustomer(null);
                                        setCustomer('');
                                        // Clear location when customer is cleared
                                        setSelectedLocation(null);
                                        setLocation('');
                                        setCustomerLocationSearch('');
                                    }
                                    setCustomerSearch(e.target.value);
                                }}
                                onFocus={(e) => {
                                    if (appointmentType === 'Edit' && selectedCustomer) return;
                                    if (selectedCustomer) {
                                        setSelectedCustomer(null);
                                        setCustomer('');
                                        setCustomerSearch('');
                                        // Clear location when customer is cleared
                                        setSelectedLocation(null);
                                        setLocation('');
                                        setCustomerLocationSearch('');
                                    }
                                    setShowCustomerDropdown(true);
                                }}
                                onBlur={() => {
                                    setTimeout(() => setShowCustomerDropdown(false), 150);
                                }}
                                disabled={appointmentType === 'Edit' && selectedCustomer}
                            />
                            {selectedCustomer && appointmentType !== 'Edit' && (
                                <button
                                    type="button"
                                    className="customer-clear-button"
                                    onClick={() => {
                                        setSelectedCustomer(null);
                                        setCustomer('');
                                        setCustomerSearch('');
                                        // Clear location when customer is cleared
                                        setSelectedLocation(null);
                                        setLocation('');
                                        setCustomerLocationSearch('');
                                    }}
                                    style={{
                                        position: 'absolute',
                                        right: '8px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        background: 'none',
                                        border: 'none',
                                        color: '#6c757d',
                                        cursor: 'pointer',
                                        fontSize: '16px',
                                        padding: '4px',
                                        borderRadius: '3px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                    onMouseEnter={(e) => e.target.style.color = '#495057'}
                                    onMouseLeave={(e) => e.target.style.color = '#6c757d'}
                                    title="Clear selection"
                                >
                                    ×
                                </button>
                            )}
                            {!selectedCustomer && showCustomerDropdown && (
                                <div className="customer-dropdown">
                                    {filteredCustomers.length > 0 ? (
                                        <>
                                            {filteredCustomers.map((customerOption, index) => (
                                                <div
                                                    key={`${customerOption.customerNumber}-${index}`}
                                                    className="customer-option"
                                                    onClick={() => {
                                                        setSelectedCustomer(customerOption);
                                                        setCustomer(`${customerOption.customerNumber} - ${customerOption.customerName}`);
                                                        setCustomerSearch('');
                                                        setShowCustomerDropdown(false);
                                                        // Clear location when customer changes
                                                        setSelectedLocation(null);
                                                        setLocation('');
                                                        setCustomerLocationSearch('');
                                                    }}
                                                >
                                                    <div className="customer-name">
                                                        {customerOption.customerNumber} - {customerOption.customerName}
                                                    </div>
                                                    <div className="customer-details">
                                                        {customerOption.customerClass} • {customerOption.status}
                                                    </div>
                                                </div>
                                            ))}
                                            {customerSearch.trim() && (
                                                <div 
                                                    className="customer-option" 
                                                    style={{ 
                                                        padding: '10px 12px', 
                                                        color: '#28a745',
                                                        fontWeight: 'bold',
                                                        fontStyle: 'italic',
                                                        cursor: 'pointer',
                                                        borderTop: '2px solid #dee2e6',
                                                        backgroundColor: '#f8f9fa'
                                                    }}
                                                    onClick={() => {
                                                        setCreatingNewCustomer(true);
                                                        setNewCustomerName(customerSearch);
                                                        setCustomerSearch('');
                                                        setShowCustomerDropdown(false);
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.backgroundColor = '#e9ecef';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.backgroundColor = '#f8f9fa';
                                                    }}
                                                >
                                                    + Create New Customer "{customerSearch}"
                                                </div>
                                            )}
                                        </>
                                    ) : customerSearch.trim() && (
                                        <div 
                                            className="customer-option" 
                                            style={{ 
                                                padding: '10px 12px', 
                                                color: '#28a745',
                                                fontWeight: 'bold',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => {
                                                setCreatingNewCustomer(true);
                                                setNewCustomerName(customerSearch);
                                                setCustomerSearch('');
                                                setShowCustomerDropdown(false);
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.backgroundColor = '#f8f9fa';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.backgroundColor = 'transparent';
                                            }}
                                        >
                                            + Create New Customer "{customerSearch}"
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>

                        </div>
                        )}
                    
                    {creatingNewCustomer && (
                        <>
                            <div className="field-service-form-group">
                                <label className="field-service-form-label required">Customer Number</label>
                                <input 
                                    type="text" 
                                    className="field-service-form-input"
                                    placeholder="Enter customer number"
                                    value={newCustomerNumber}
                                    onChange={(e) => setNewCustomerNumber(e.target.value)}
                                />
                            </div>
                            <div className="field-service-form-group">
                                <label className="field-service-form-label required">Customer Name</label>
                                <input 
                                    type="text" 
                                    className="field-service-form-input"
                                    placeholder="Enter customer name"
                                    value={newCustomerName}
                                    onChange={(e) => setNewCustomerName(e.target.value)}
                                />
                            </div>
                            <div className="field-service-form-group">
                                <label className="field-service-form-label required">Customer Class</label>
                                <input 
                                    type="text" 
                                    className="field-service-form-input"
                                    placeholder="Enter customer class"
                                    value={newCustomerClass}
                                    onChange={(e) => setNewCustomerClass(e.target.value)}
                                />
                            </div>
                            <div className="field-service-form-group" style={{ display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center', marginTop: '5px' }}>
                                <button 
                                    type="button"
                                    className="field-service-form-button"
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: 'white',
                                        padding: '8px 16px',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        flex: 1
                                    }}
                                    onClick={() => {
                                        setCreatingNewCustomer(false);
                                        setNewCustomerNumber('');
                                        setNewCustomerName('');
                                        setNewCustomerClass('');
                                    }}
                                >
                                    Cancel
                                </button>
                                <button 
                                    type="button"
                                    className="field-service-form-button"
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: 'white',
                                        padding: '8px 16px',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        flex: 1
                                    }}
                                    onClick={() => {
                                        if (newCustomerNumber && newCustomerNumber.trim() && newCustomerName && newCustomerName.trim() && newCustomerClass && newCustomerClass.trim()) {
                                            // Create temporary customer object
                                            const newCustomer = {
                                                customerNumber: newCustomerNumber.trim(),
                                                customerName: newCustomerName.trim(),
                                                customerClass: newCustomerClass.trim(),
                                                status: 'Active',
                                                isNew: true
                                            };
                                            setSelectedCustomer(newCustomer);
                                            setCustomer(`${newCustomer.customerNumber} - ${newCustomer.customerName}`);
                                            setCreatingNewCustomer(false);
                                        } else {
                                            alert('Please fill in all required customer fields (cannot be empty or only spaces)');
                                        }
                                    }}
                                >
                                    Save Customer
                                </button>
                            </div>
                        </>
                    )}
                            
                            <div className="field-service-form-row single">
                                <div className="field-service-form-group">
                                    <label className="field-service-form-label">Project Number</label>
                                    <input 
                                        type="text" 
                                        className="field-service-form-input"
                                        placeholder="Enter project number"
                                        value={project}
                                        onChange={(e) => setProject(e.target.value)}
                                    />
                                </div>
                            </div>
                        </>
                )}
                
                {selectedCustomer && appointmentType === 'Edit' && (
                    <div className="field-service-form-row">
                        <div className="field-service-form-group">
                            <button
                                type="button"
                                onClick={() => {
                                    setSelectedCustomer(null);
                                    setCustomer('');
                                    setCustomerSearch('');
                                    // Clear location and contact information when changing customer
                                    setSelectedLocation(null);
                                    setLocation('');
                                    setCustomerLocationSearch('');
                                    setAddress('');
                                    setAddress2('');
                                    setCity('');
                                    setState('');
                                    setZip('');
                                    setCountry('US');
                                    setSelectedContact(null);
                                    setContact('');
                                    setContactSearch('');
                                    setTitle('');
                                    setPhone('');
                                    setEmail('');
                                }}
                                style={{
                                    width: '100%',
                                    padding: '10px 16px',
                                    backgroundColor: 'white',
                                    color: 'var(--primary-color)',
                                    border: '2px solid var(--primary-color)',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    transition: 'all 0.2s'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = 'var(--primary-color)';
                                    e.target.style.color = 'white';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = 'white';
                                    e.target.style.color = 'var(--primary-color)';
                                }}
                                title="This will clear location and contact information"
                            >
                                Change Customer
                            </button>
                        </div>
                    </div>
                )}
            </div>


            {/* Location Information */}
            <div className="field-service-form-section">
                <h4 className="field-service-form-section-title">📍 Location</h4>
                
                <div className="field-service-form-row single">
                    <div className="field-service-form-group">
                        <label className="field-service-form-label required">Location Name</label>
                        <div className="customer-search-container">
                            <input 
                                type="text" 
                                className="field-service-form-input"
                                placeholder={!selectedCustomer ? "Select a customer first" : (selectedLocation ? "" : "Search locations or enter new...")}
                                value={selectedLocation ? selectedLocation.locationName : customerLocationSearch}
                                onChange={(e) => {
                                    if (appointmentType === 'Edit' && selectedLocation) return;
                                    if (selectedLocation) {
                                        setSelectedLocation(null);
                                        setLocation('');
                                    }
                                    setCustomerLocationSearch(e.target.value);
                                }}
                                onFocus={() => {
                                    if (appointmentType === 'Edit' && selectedLocation) return;
                                    if (selectedCustomer) {
                                        if (selectedLocation) {
                                            setSelectedLocation(null);
                                            setLocation('');
                                            setCustomerLocationSearch('');
                                        }
                                        setShowLocationDropdown(true);
                                    }
                                }}
                                onBlur={() => {
                                    setTimeout(() => setShowLocationDropdown(false), 150);
                                }}
                                disabled={!selectedCustomer || (appointmentType === 'Edit' && selectedLocation)}
                            />
                            {(customerLocationSearch || selectedLocation) && selectedCustomer && !(appointmentType === 'Edit' && selectedLocation) && (
                                <button 
                                    className="customer-clear-button"
                                    onClick={() => {
                                        setCustomerLocationSearch('');
                                        setSelectedLocation(null);
                                        setLocation('');
                                        setShowLocationDropdown(false);
                                    }}
                                    type="button"
                                    style={{
                                        position: 'absolute',
                                        right: '8px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        background: 'none',
                                        border: 'none',
                                        color: '#6c757d',
                                        cursor: 'pointer',
                                        fontSize: '16px',
                                        padding: '4px',
                                        borderRadius: '3px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                    onMouseEnter={(e) => e.target.style.color = '#495057'}
                                    onMouseLeave={(e) => e.target.style.color = '#6c757d'}
                                >
                                    ×
                                </button>
                            )}
                            {showLocationDropdown && selectedCustomer && !(appointmentType === 'Edit' && selectedLocation) && (
                                <div className="customer-dropdown">
                                    {filteredLocations.length > 0 ? (
                                        filteredLocations.map((locationOption) => (
                                            <div 
                                                key={locationOption.locationID}
                                                className="customer-option"
                                                onMouseDown={(e) => {
                                                    e.preventDefault();
                                                    setSelectedLocation(locationOption);
                                                    setLocation(locationOption.locationName);
                                                    setCustomerLocationSearch('');
                                                    setShowLocationDropdown(false);
                                                    
                                                    // Populate address fields from location
                                                    if (locationOption.address) {
                                                        setAddress(locationOption.address.street || '');
                                                        setAddress2(locationOption.address.street2 || '');
                                                        setCity(locationOption.address.city || '');
                                                        setState(locationOption.address.state || '');
                                                        setZip(locationOption.address.zip || '');
                                                        setCountry(locationOption.address.country || 'US');
                                                    }
                                                    
                                                    // Clear contact fields - will be populated when contact is selected
                                                    setContact('');
                                                    setTitle('');
                                                    setPhone('');
                                                    setEmail('');
                                                    setContactSearch('');
                                                    setSelectedContact(null);
                                                }}
                                            >
                                                <div className="customer-option-main">
                                                    <span className="customer-name">{locationOption.locationName}</span>
                                                </div>
                                                <div className="customer-option-details">
                                                    {locationOption.address 
                                                        ? `${locationOption.address.street || ''} ${locationOption.address.city || ''}, ${locationOption.address.state || ''} ${locationOption.address.zip || ''}`.trim()
                                                        : ''
                                                    }
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div 
                                            className="customer-option" 
                                            style={{ 
                                                padding: '10px 12px', 
                                                color: '#28a745',
                                                fontWeight: 'bold',
                                                cursor: 'pointer'
                                            }}
                                            onMouseDown={(e) => {
                                                e.preventDefault();
                                                setShowLocationDropdown(false);
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.backgroundColor = '#f8f9fa';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.backgroundColor = 'transparent';
                                            }}
                                        >
                                            + Add New Location "{customerLocationSearch}"
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                
                <div className="field-service-form-row single">
                    <div className="field-service-form-group">
                        <label className="field-service-form-label required">Street Address</label>
                        <input 
                            type="text" 
                            className="field-service-form-input"
                            placeholder="Enter street address"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            disabled={!selectedCustomer || selectedLocation}
                        />
                    </div>
                </div>

                <div className="field-service-form-row single">
                    <div className="field-service-form-group">
                        <label className="field-service-form-label">Address Line 2</label>
                        <input 
                            type="text" 
                            className="field-service-form-input"
                            placeholder="Apartment, suite, unit, etc."
                            value={address2}
                            onChange={(e) => setAddress2(e.target.value)}
                            disabled={!selectedCustomer || selectedLocation}
                        />
                    </div>
                </div>

                <div className="field-service-form-row triple">
                    <div className="field-service-form-group">
                        <label className="field-service-form-label required">City</label>
                        <input 
                            type="text" 
                            className="field-service-form-input"
                            placeholder="Enter city"
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                            disabled={!selectedCustomer || selectedLocation}
                        />
                    </div>
                    <div className="field-service-form-group">
                        <label className="field-service-form-label required">State</label>
                        <select 
                            className="field-service-form-select"
                            value={state}
                            onChange={(e) => setState(e.target.value)}
                            disabled={!selectedCustomer || selectedLocation}
                        >
                            <option value="">Select State</option>
                            <option value="AL">Alabama</option>
                            <option value="AK">Alaska</option>
                            <option value="AZ">Arizona</option>
                            <option value="AR">Arkansas</option>
                            <option value="CA">California</option>
                            <option value="CO">Colorado</option>
                            <option value="CT">Connecticut</option>
                            <option value="DE">Delaware</option>
                            <option value="FL">Florida</option>
                            <option value="GA">Georgia</option>
                            <option value="HI">Hawaii</option>
                            <option value="ID">Idaho</option>
                            <option value="IL">Illinois</option>
                            <option value="IN">Indiana</option>
                            <option value="IA">Iowa</option>
                            <option value="KS">Kansas</option>
                            <option value="KY">Kentucky</option>
                            <option value="LA">Louisiana</option>
                            <option value="ME">Maine</option>
                            <option value="MD">Maryland</option>
                            <option value="MA">Massachusetts</option>
                            <option value="MI">Michigan</option>
                            <option value="MN">Minnesota</option>
                            <option value="MS">Mississippi</option>
                            <option value="MO">Missouri</option>
                            <option value="MT">Montana</option>
                            <option value="NE">Nebraska</option>
                            <option value="NV">Nevada</option>
                            <option value="NH">New Hampshire</option>
                            <option value="NJ">New Jersey</option>
                            <option value="NM">New Mexico</option>
                            <option value="NY">New York</option>
                            <option value="NC">North Carolina</option>
                            <option value="ND">North Dakota</option>
                            <option value="OH">Ohio</option>
                            <option value="OK">Oklahoma</option>
                            <option value="OR">Oregon</option>
                            <option value="PA">Pennsylvania</option>
                            <option value="RI">Rhode Island</option>
                            <option value="SC">South Carolina</option>
                            <option value="SD">South Dakota</option>
                            <option value="TN">Tennessee</option>
                            <option value="TX">Texas</option>
                            <option value="UT">Utah</option>
                            <option value="VT">Vermont</option>
                            <option value="VA">Virginia</option>
                            <option value="WA">Washington</option>
                            <option value="WV">West Virginia</option>
                            <option value="WI">Wisconsin</option>
                            <option value="WY">Wyoming</option>
                        </select>
                    </div>
                    <div className="field-service-form-group">
                        <label className="field-service-form-label required">ZIP Code</label>
                        <input 
                            type="text" 
                            className="field-service-form-input"
                            placeholder="Enter ZIP"
                            value={zip}
                            onChange={(e) => setZip(e.target.value)}
                            disabled={!selectedCustomer || selectedLocation}
                        />
                    </div>
                </div>
                
                {selectedLocation && appointmentType === 'Edit' && (
                    <div className="field-service-form-row">
                        <div className="field-service-form-group">
                            <button
                                type="button"
                                onClick={() => {
                                    setSelectedLocation(null);
                                    setLocation('');
                                    setCustomerLocationSearch('');
                                    setAddress('');
                                    setAddress2('');
                                    setCity('');
                                    setState('');
                                    setZip('');
                                    setCountry('US');
                                    setSelectedContact(null);
                                    setContact('');
                                    setContactSearch('');
                                    setTitle('');
                                    setPhone('');
                                    setEmail('');
                                }}
                                style={{
                                    width: '100%',
                                    padding: '10px 16px',
                                    backgroundColor: 'white',
                                    color: 'var(--primary-color)',
                                    border: '2px solid var(--primary-color)',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    transition: 'all 0.2s'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = 'var(--primary-color)';
                                    e.target.style.color = 'white';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = 'white';
                                    e.target.style.color = 'var(--primary-color)';
                                }}
                                title="This will clear location and contact information"
                            >
                                Change Location
                            </button>
                        </div>
                    </div>
                )}
                
                {/* Create New Location Option - Only show when address override is enabled 
                {overrideAddress && (
                    <div className="field-service-form-row single">
                        <div className="field-service-form-group">
                            <div className="field-service-create-option-checkbox">
                                <input 
                                    type="checkbox" 
                                    id="create-new-location"
                                    checked={createNewLocation}
                                    onChange={(e) => setCreateNewLocation(e.target.checked)}
                                />
                                <label htmlFor="create-new-location">Create New Location</label>
                            </div>
                        </div>
                    </div>
                )}
                */}
            </div>

            {/* Contact Information */}
            <div className="field-service-form-section">
                <h4 className="field-service-form-section-title">👤 Contact Information</h4>
                
                <div className="field-service-form-row">
                    <div className="field-service-form-group">
                        <label className="field-service-form-label required">Contact Name</label>
                        <div className="customer-search-container">
                            <input 
                                type="text" 
                                className="field-service-form-input"
                                placeholder={!selectedLocation && !customerLocationSearch ? "Select or enter a location first" : (selectedContact ? "" : "Search contacts or enter new...")}
                                value={selectedContact ? selectedContact.name : (contactSearch || contact)}
                                onChange={(e) => {
                                    if (appointmentType === 'Edit' && selectedContact) return;
                                    if (selectedContact) {
                                        setSelectedContact(null);
                                    }
                                    setContactSearch(e.target.value);
                                    setContact(e.target.value);
                                }}
                                onFocus={() => {
                                    if (appointmentType === 'Edit' && selectedContact) return;
                                    if (selectedLocation || customerLocationSearch) {
                                        if (selectedContact) {
                                            setSelectedContact(null);
                                            setContactSearch('');
                                        }
                                        setShowContactDropdown(true);
                                    }
                                }}
                                onBlur={() => {
                                    setTimeout(() => setShowContactDropdown(false), 150);
                                }}
                                disabled={(!selectedLocation && !customerLocationSearch) || (appointmentType === 'Edit' && selectedContact)}
                            />
                            {(contactSearch || selectedContact) && (selectedLocation || customerLocationSearch) && !(appointmentType === 'Edit' && selectedContact) && (
                                <button 
                                    className="customer-clear-button"
                                    onClick={() => {
                                        setContactSearch('');
                                        setSelectedContact(null);
                                        setContact('');
                                        setShowContactDropdown(false);
                                    }}
                                    type="button"
                                    style={{
                                        position: 'absolute',
                                        right: '8px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        background: 'none',
                                        border: 'none',
                                        color: '#6c757d',
                                        cursor: 'pointer',
                                        fontSize: '16px',
                                        padding: '4px',
                                        borderRadius: '3px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                    onMouseEnter={(e) => e.target.style.color = '#495057'}
                                    onMouseLeave={(e) => e.target.style.color = '#6c757d'}
                                >
                                    ×
                                </button>
                            )}
                            {showContactDropdown && (selectedLocation || customerLocationSearch) && !(appointmentType === 'Edit' && selectedContact) && (
                                <div className="customer-dropdown">
                                    {selectedLocation && filteredContacts.length > 0 ? (
                                        filteredContacts.map((contactOption, index) => (
                                            <div 
                                                key={contactOption.id || index}
                                                className="customer-option"
                                                onMouseDown={(e) => {
                                                    e.preventDefault();
                                                    setSelectedContact(contactOption);
                                                    setContact(contactOption.name);
                                                    setContactSearch('');
                                                    setShowContactDropdown(false);
                                                    
                                                    // Populate other contact fields
                                                    setTitle(contactOption.title || '');
                                                    setPhone(contactOption.number || '');
                                                    setEmail(contactOption.email || '');
                                                }}
                                            >
                                                <div className="customer-option-main">
                                                    <span className="customer-name">{contactOption.name}</span>
                                                </div>
                                                <div className="customer-option-details">
                                                    {contactOption.email || contactOption.number || ''}
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div 
                                            className="customer-option" 
                                            style={{ 
                                                padding: '10px 12px', 
                                                color: '#28a745',
                                                fontWeight: 'bold',
                                                cursor: 'pointer'
                                            }}
                                            onMouseDown={(e) => {
                                                e.preventDefault();
                                                setShowContactDropdown(false);
                                                setContact(contactSearch);
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.backgroundColor = '#f8f9fa';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.backgroundColor = 'transparent';
                                            }}
                                        >
                                            + Add New Contact{contactSearch ? ` "${contactSearch}"` : ''}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="field-service-form-group">
                        <label className="field-service-form-label">Title</label>
                        <input 
                            type="text" 
                            className="field-service-form-input"
                            placeholder="Enter job title"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            disabled={(!selectedLocation && !customerLocationSearch) || selectedContact !== null}
                        />
                    </div>
                </div>

                <div className="field-service-form-row">
                    <div className="field-service-form-group">
                        <label className="field-service-form-label">Phone</label>
                        <input 
                            type="tel" 
                            className="field-service-form-input"
                            placeholder="(555) 123-4567"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            disabled={(!selectedLocation && !customerLocationSearch) || selectedContact !== null}
                        />
                    </div>
                    <div className="field-service-form-group">
                        <label className="field-service-form-label required">Email</label>
                        <input 
                            type="email" 
                            className="field-service-form-input"
                            placeholder="contact@email.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            disabled={(!selectedLocation && !customerLocationSearch) || selectedContact !== null}
                        />
                    </div>
                </div>
                
                {selectedContact && appointmentType === 'Edit' && (
                    <div className="field-service-form-row">
                        <div className="field-service-form-group">
                            <button
                                type="button"
                                onClick={() => {
                                    setSelectedContact(null);
                                    setContact('');
                                    setContactSearch('');
                                    setTitle('');
                                    setPhone('');
                                    setEmail('');
                                }}
                                style={{
                                    width: '100%',
                                    padding: '10px 16px',
                                    backgroundColor: 'white',
                                    color: 'var(--primary-color)',
                                    border: '2px solid var(--primary-color)',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    transition: 'all 0.2s'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = 'var(--primary-color)';
                                    e.target.style.color = 'white';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = 'white';
                                    e.target.style.color = 'var(--primary-color)';
                                }}
                                title="This will clear contact information"
                            >
                                Change Contact
                            </button>
                        </div>
                    </div>
                )}
            </div>

            {/* Related Appointment Section */}
            <div className="field-service-form-section">
                <h4 className="field-service-form-section-title">🔄 Related Appointment</h4>
                
                <div className="field-service-form-row single">
                    <div className="field-service-form-group">
                        <label className="field-service-form-label">Related Appointment (Optional)</label>
                        <div className="customer-search-container">
                            <input 
                                type="text" 
                                className="field-service-form-input"
                                placeholder={
                                    !selectedCustomer ? "Select a customer first" :
                                    !selectedLocation ? "Select a location first" :
                                    previousAppointments.length === 0 ? "No previously completed appointments exist for this customer and location" :
                                    "Search appointments by ID, description, or type"
                                }
                                value={previousAppointmentSearch}
                                onChange={(e) => setPreviousAppointmentSearch(e.target.value)}
                                onFocus={() => {
                                    if (previousAppointments.length > 0) {
                                        setShowPreviousAppointmentsDropdown(true);
                                    }
                                }}
                                onBlur={() => {
                                    setTimeout(() => setShowPreviousAppointmentsDropdown(false), 200);
                                }}
                                disabled={!selectedCustomer || !selectedLocation || previousAppointments.length === 0}
                            />
                            {showPreviousAppointmentsDropdown && filteredPreviousAppointments.length > 0 && (
                                <div className="previous-appointments-dropdown">
                                    {filteredPreviousAppointments.map((appointment) => (
                                        <div
                                            key={appointment.appointmentID}
                                            className="previous-appointment-item"
                                            onMouseDown={(e) => {
                                                e.preventDefault();
                                                setSelectedPreviousAppointment(appointment);
                                                setPreviousAppointmentSearch(`${appointment.appointmentID} - ${appointment.description}`);
                                                setRelatedAppointment(appointment.id);
                                                setShowPreviousAppointmentsDropdown(false);
                                            }}
                                        >
                                            <span className="previous-appointment-id">
                                                📋 #{appointment.appointmentID}
                                            </span>
                                            <span className="previous-appointment-description">
                                                {appointment.description}
                                            </span>
                                            <div className="previous-appointment-metadata">
                                                <span className="previous-appointment-type">
                                                    {appointment.type}
                                                </span>
                                                <span className="previous-appointment-date">
                                                    📅 {new Date(appointment.scheduledStart).toLocaleDateString()}
                                                </span>
                                                <span className={`previous-appointment-status ${appointment.fsrComplete ? 'completed' : 'not-complete'}`}>
                                                    {appointment.fsrComplete ? '✓ Completed' : '⏳ Not Complete'}
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Assignment & Options */}
            <div className="field-service-form-section">
                <h4 className="field-service-form-section-title">⚙️ Assignment & Options</h4>
                
                <div className="field-service-form-row single">
                    <div className="field-service-form-group">
                        <label className="field-service-form-label">Assigned Technicians</label>
                        
                        {/* Selected Technicians Display */}
                        {selectedTechnicians.length > 0 && (
                            <div className="selected-technicians-container" style={{ marginBottom: '8px' }}>
                                {selectedTechnicians.map((tech) => (
                                    <div key={tech.id} className="selected-technician" style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        backgroundColor: '#e9ecef',
                                        border: '1px solid #ced4da',
                                        borderRadius: '4px',
                                        padding: '6px 10px',
                                        margin: '2px',
                                        fontSize: '14px',
                                        position: 'relative'
                                    }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', marginRight: '8px' }}>
                                            <span style={{ fontWeight: 'bold', color: 'var(--primary-color)', lineHeight: '1.2' }}>{tech.name}</span>
                                            <span style={{ color: '#6c757d', fontSize: '12px', lineHeight: '1.2', marginTop: '2px' }}>{tech.email}</span>
                                        </div>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                const updatedTechnicians = selectedTechnicians.filter(t => t.id !== tech.id);
                                                setSelectedTechnicians(updatedTechnicians);
                                                setAssignedTo(updatedTechnicians.map(t => `${t.name} (${t.email})`));
                                            }}
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                color: '#6c757d',
                                                cursor: 'pointer',
                                                fontSize: '16px',
                                                padding: '0',
                                                lineHeight: '1'
                                            }}
                                        >
                                            ×
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* Technician Search Field */}
                        <div className="customer-search-container">
                            <input 
                                type="text" 
                                className="field-service-form-input"
                                placeholder="Search technicians by name..."
                                value={technicianSearch}
                                onChange={(e) => setTechnicianSearch(e.target.value)}
                                onFocus={() => setShowTechnicianDropdown(true)}
                                onBlur={() => {
                                    setTimeout(() => setShowTechnicianDropdown(false), 150);
                                }}
                            />
                            {technicianSearch && (
                                <button 
                                    className="customer-clear-button"
                                    onClick={() => {
                                        setTechnicianSearch('');
                                        setShowTechnicianDropdown(false);
                                    }}
                                    type="button"
                                >
                                    ×
                                </button>
                            )}
                            {(showTechnicianDropdown || technicianSearch) && (
                                <div className="customer-dropdown">
                                    {(() => {
                                        const availableTechs = searchFilteredTechnicians
                                            .filter(tech => !selectedTechnicians.some(selected => selected.id === tech.id));
                                        
                                        console.log('searchFilteredTechnicians:', searchFilteredTechnicians);
                                        console.log('availableTechs after filter:', availableTechs);
                                        console.log('selectedTechnicians:', selectedTechnicians);
                                        
                                        return availableTechs.length > 0 ? (
                                            availableTechs.map((techOption) => (
                                                <div 
                                                    key={techOption.id}
                                                    className="customer-option"
                                                    onMouseDown={(e) => {
                                                        e.preventDefault();
                                                        const updatedTechnicians = [...selectedTechnicians, techOption];
                                                        setSelectedTechnicians(updatedTechnicians);
                                                        setAssignedTo(updatedTechnicians.map(t => `${t.name} (${t.email})`));
                                                        setTechnicianSearch('');
                                                        setShowTechnicianDropdown(false);
                                                    }}
                                                >
                                                    <div className="customer-option-main" style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <span className="customer-name" style={{ fontWeight: 'bold', color: 'var(--primary-color)', lineHeight: '1.3' }}>{techOption.name}</span>
                                                        <span className="customer-number" style={{ color: '#6c757d', fontSize: '12px', lineHeight: '1.3' }}>{techOption.email}</span>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="customer-option" style={{ padding: '10px 12px', color: '#6c757d', fontStyle: 'italic' }}>
                                                {searchFilteredTechnicians.length === 0 
                                                    ? 'No technicians loaded. Check console for details.'
                                                    : 'All technicians already selected'}
                                            </div>
                                        );
                                    })()}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="field-service-form-row single">
                    <div className="field-service-form-group">                            
                        <div className="field-service-form-checkbox-group">
                            <input 
                                type="checkbox" 
                                className="field-service-form-checkbox"
                                id="notifyTechs"
                                checked={notifyTechs}
                                onChange={(e) => setNotifyTechs(e.target.checked)}
                            />
                            <label htmlFor="notifyTechs" className="field-service-form-checkbox-label">
                                Notify Technicians of Appointment
                            </label>
                        </div>  
                        <div className="field-service-form-checkbox-group">
                            <input 
                                type="checkbox" 
                                className="field-service-form-checkbox"
                                id="requireFSR"
                                checked={requireFSR}
                                onChange={(e) => setRequireFSR(e.target.checked)}
                            />
                            <label htmlFor="requireFSR" className="field-service-form-checkbox-label">
                                Require Field Service Report (FSR) on completion
                            </label>
                        </div>
                        {   requireFSR &&
                            <>                               
                            <div className="field-service-form-checkbox-group">
                                <input 
                                    type="checkbox" 
                                    className="field-service-form-checkbox"
                                    id="autosendFSR"
                                    checked={autosendFSR}
                                    onChange={(e) => setAutosendFSR(e.target.checked)}
                                />
                                <label htmlFor="autosendFSR" className="field-service-form-checkbox-label">
                                    Autosend Field Service Report (FSR) on completion
                                </label>
                            </div>
                            </>
                        }
                    </div>
                </div>
                {
                    type === 'PM' &&
                    <div className="field-service-form-row single">
                        <div className="field-service-form-group">
                            <label className="field-service-form-label">Preventative Maintenance (PM) Checklist Link</label>
                            <input 
                                type="text" 
                                className="field-service-form-input"
                                id="pmChecklist"
                                value={pmChecklist}
                                onChange={(e) => setPmChecklist(e.target.value)}
                            />
                        </div>
                    </div>
                }

                <div className="field-service-form-row single">
                    <div className="field-service-form-group">
                        <label className="field-service-form-label required">Appointment Description</label>
                        <input 
                            type="text" 
                            className="field-service-form-input"
                            id="appointmentDescription"
                            value={appointmentDescription}
                            onChange={(e) => setAppointmentDescription(e.target.value)}
                            placeholder="Enter appointment description"
                        />
                    </div>
                </div>

                <div className="field-service-form-row single">
                    <div className="field-service-form-group">
                        <label className="field-service-form-label">File Sharing Folder Link (Shared Links if not in Box)</label>
                        <input 
                            type="text" 
                            className="field-service-form-input"
                            id="fileShareLink"
                            checked={fileShareLink}
                            value={fileShareLink}
                            onChange={(e) => setFileShareLink(e.target.value)}
                        />
                    </div>
                </div>

                <div className="field-service-form-row single">
                    <div className="field-service-form-group">
                        <label className="field-service-form-label">Notes</label>
                        <textarea 
                            className="field-service-form-textarea"
                            placeholder="Enter appointment notes, special instructions, or additional information..."
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                            rows={4}
                        />
                    </div>
                </div>
            </div>
            </fieldset>

            {/* Validation Summary */}
            {!isReadOnly && !isFormValid() && (
                <div className="field-service-validation-summary">
                    <h4>⚠️ Please complete the following required fields:</h4>
                    <ul>
                        {(!startDate || !endDate || !startTime || !endTime || !type) && (
                            <li>Complete all Basic Information fields</li>
                        )}
                        {(!selectedCustomer || !selectedCustomer.customerNumber) && (
                            <li>Select a Customer</li>
                        )}
                        {(!address.trim() || !city.trim() || !state || !zip.trim()) && (
                            <li>Complete Address fields (Street Address, City, State, ZIP Code)</li>
                        )}
                        {(!contact.trim() || !email.trim()) && (
                            <li>Enter Contact Name and Email address</li>
                        )}
                        {(!selectedTechnicians || selectedTechnicians.length === 0) && (
                            <li>Assign at least one Technician</li>
                        )}
                        {!appointmentDescription.trim() && (
                            <li>Enter Appointment Description</li>
                        )}
                    </ul>
                </div>
            )}

            {/* Form Actions */}
            <div className="field-service-form-actions">
                {!isReadOnly && appointmentType === 'Edit' && (
                    <button 
                        type="button" 
                        className="field-service-form-button danger"
                        onClick={deleteAppointment}
                    >
                        Delete
                    </button>
                )}
                <div className="field-service-form-actions-right">
                    <button 
                        type="button" 
                        className="field-service-form-button secondary"
                        onClick={handleCancel}
                    >
                        {isReadOnly ? 'Close' : 'Cancel'}
                    </button>
                    {!isReadOnly && (
                        <button 
                            type="button" 
                            className={`field-service-form-button primary ${!isFormValid() ? 'disabled' : ''}`}
                            onClick={createAppointmentObject}
                            disabled={!isFormValid()}
                            title={!isFormValid() ? 'Please fill all required fields' : ''}
                        >
                            {appointmentType === 'New' ? 'Create Appointment' : 'Update Appointment'}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

const AppointmentComponent = ({ onClose, branchSelected,setBranchSelected,filteredTechnicians,apiToken,currentUser,submitAppointment,appointmentLoading,appointmentSuccess,appointmentError,appointmentType,existingAppointmentObject,setExistingAppointmentObject,refreshAppointments,isReadOnly = false }) => {
    const [customerSearch, setCustomerSearch] = useState('');
    const [customers, setCustomers] = useState([]);
    const [customersError, setCustomersError] = useState(null);
    const [customersLoading, setCustomersLoading] = useState(false);
    const [filteredCustomers, setFilteredCustomers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const [createNewLocationToggle, setCreateNewLocationToggle] = useState(false);
    const [customerLocationSearch, setCustomerLocationSearch] = useState('');
    const [customerLocations, setCustomerLocations] = useState([]);
    const [customerLocationsError, setCustomerLocationsError] = useState(null);
    const [filteredLocations, setFilteredLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState(null);

    const [selectedTechnicians, setSelectedTechnicians] = useState([]);
    const [technicianSearch, setTechnicianSearch] = useState('');
    const [searchFilteredTechnicians, setSearchFilteredTechnicians] = useState([]);

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());

    const [startTime, setStartTime] = useState('08:00');
    const [endTime, setEndTime] = useState('17:00');

    const [project, setProject] = useState('');
    const [customer, setCustomer] = useState('');
    const [location, setLocation] = useState('');

    const [address, setAddress] = useState('');
    const [address2, setAddress2] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [zip, setZip] = useState('');
    const [country, setCountry] = useState('US');

    const [contact, setContact] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [title, setTitle] = useState('');

    const [type, setType] = useState('SC');

    const [appointmentDescription, setAppointmentDescription] = useState('');

    const [assignedTo, setAssignedTo] = useState([]);
    const [notes, setNotes] = useState('');

    const [notifyTechs, setNotifyTechs] = useState(true);
    const [requireFSR, setRequireFSR] = useState(true);
    const [autosendFSR, setAutosendFSR] = useState(true);
    const [multipleFSRs, setMultipleFSRs] = useState(true);

    const [pmChecklist, setPmChecklist] = useState('');
    const [fileShareLink, setFileShareLink] = useState('');

    const [overrideAddress, setOverrideAddress] = useState(false);
    const [overrideContact, setOverrideContact] = useState(false);

    const [createNewLocation, setCreateNewLocation] = useState(false);
    const [createNewContact, setCreateNewContact] = useState(false);

    const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
    const [showLocationDropdown, setShowLocationDropdown] = useState(false);
    const [showTechnicianDropdown, setShowTechnicianDropdown] = useState(false);
    const [showContactDropdown, setShowContactDropdown] = useState(false);
    
    const [contactSearch, setContactSearch] = useState('');
    const [filteredContacts, setFilteredContacts] = useState([]);
    const [selectedContact, setSelectedContact] = useState(null);

    const [creatingNewCustomer, setCreatingNewCustomer] = useState(false);
    const [newCustomerNumber, setNewCustomerNumber] = useState('');
    const [newCustomerName, setNewCustomerName] = useState('');
    const [newCustomerClass, setNewCustomerClass] = useState('');

    // Previous appointments state variables
    const [previousAppointments, setPreviousAppointments] = useState([]);
    const [previousAppointmentsError, setPreviousAppointmentsError] = useState(null);
    const [relatedAppointment, setRelatedAppointment] = useState('');
    const [showPreviousAppointmentsDropdown, setShowPreviousAppointmentsDropdown] = useState(false);
    const [previousAppointmentSearch, setPreviousAppointmentSearch] = useState('');
    const [filteredPreviousAppointments, setFilteredPreviousAppointments] = useState([]);
    const [selectedPreviousAppointment, setSelectedPreviousAppointment] = useState(null);

    useEffect(() => {
        // Only auto-sync endDate with startDate for new appointments, not when editing existing ones
        if (appointmentType === 'New' && !existingAppointmentObject) {
            setEndDate(new Date(startDate));
        }
    }, [startDate, appointmentType, existingAppointmentObject]);

    useEffect(() => {
        const originalStyle = window.getComputedStyle(document.body).overflow;
        document.body.style.overflow = 'hidden';
        
        return () => {
            document.body.style.overflow = originalStyle;
        };
    }, []);

    const resetFields = () => {
        console.log("Resetting fields to default values");
        setStartDate(new Date());
        setEndDate(new Date());
        setStartTime('08:00');
        setEndTime('17:00');
        setProject('');
        setCustomer('');
        setLocation('');
        setAddress('');
        setAddress2('');
        setCity('');
        setState('');
        setZip('');
        setCountry('US');
        setContact('');
        setPhone('');
        setEmail('');
        setTitle('');
        setType('SC');
        setAppointmentDescription('');
        setAssignedTo([]);
        setNotes('');
        setNotifyTechs(true);
        setRequireFSR(true);
        setAutosendFSR(true);
        setPmChecklist('');
        setFileShareLink('');
        setOverrideAddress(false);
        setOverrideContact(false);
        setCreateNewLocation(false);
        setCreateNewContact(false);
        setShowCustomerDropdown(false);
        setShowLocationDropdown(false);
        setShowTechnicianDropdown(false);
        setShowContactDropdown(false);
        setContactSearch('');
        setFilteredContacts([]);
        setSelectedContact(null);
        setCreatingNewCustomer(false);
        setNewCustomerNumber('');
        setNewCustomerName('');
        setNewCustomerClass('');
        setPreviousAppointments([]);
        setSelectedPreviousAppointment(null);
        setRelatedAppointment('');
        setPreviousAppointmentSearch('');
        setShowPreviousAppointmentsDropdown(false);
        setExistingAppointmentObject(null);
    };

    useEffect(() => {
        if(customers.length === 0){
            getAllCustomers(apiToken, setCustomers, setCustomersError, setCustomersLoading);
        };
        resetFields();
    }, []);

    // Fetch customer locations when a customer is selected
    useEffect(() => {
        if (selectedCustomer && selectedCustomer.id && !selectedCustomer.isNew) {
            getCustomerLocations(apiToken, selectedCustomer.id, setCustomerLocations, setCustomerLocationsError);
        }
    }, [selectedCustomer, apiToken, appointmentType]);

    // Fetch previous appointments when both customer and location are selected
    useEffect(() => {
        if (selectedCustomer && selectedCustomer.id && selectedLocation && selectedLocation.locationID && appointmentType === 'New') {
            getPreviousAppointments(apiToken, selectedCustomer.id, selectedLocation.locationID, setPreviousAppointments, setPreviousAppointmentsError);
        } else {
            setPreviousAppointments([]);
            setSelectedPreviousAppointment(null);
            setRelatedAppointment('');
        }
    }, [selectedCustomer, selectedLocation, apiToken, appointmentType]);

    useEffect(() => {
        if(existingAppointmentObject){
            setAppointmentDescription(existingAppointmentObject.description || existingAppointmentObject.appointmentDescription || '');
            
            setOverrideAddress(existingAppointmentObject.overrideAddress || false);
            setOverrideContact(existingAppointmentObject.overrideContact || false);
            setFileShareLink(existingAppointmentObject.fileShareLink || '');
            setNotes(existingAppointmentObject.officeNotes || existingAppointmentObject.notes || '');
            setNotifyTechs(existingAppointmentObject.notifyTechs ? existingAppointmentObject.notifyTechs : true);
            setRequireFSR(existingAppointmentObject.requireFSR ? existingAppointmentObject.requireFSR : true);
            setAutosendFSR(existingAppointmentObject.autosendFSR ? existingAppointmentObject.autosendFSR : true);
            setType(existingAppointmentObject.type || 'SC');
            setPmChecklist(existingAppointmentObject.pmChecklist || '');

            setProject(existingAppointmentObject.projectNumber || existingAppointmentObject.projectID || '');
            
            // Handle customer - could have customer object or customerID
            if (existingAppointmentObject.customer) {
                setCustomer(existingAppointmentObject.customer.customerNumber || existingAppointmentObject.customer.id || '');
                setSelectedCustomer(existingAppointmentObject.customer);
            } else if (existingAppointmentObject.customerID) {
                setCustomer(existingAppointmentObject.customerID);
            }
            
            // Handle location - could have location object or locationID
            if (existingAppointmentObject.location) {
                setLocation(existingAppointmentObject.location.locationID || existingAppointmentObject.location.id || '');
                setSelectedLocation(existingAppointmentObject.location);
            } else if (existingAppointmentObject.locationID) {
                setLocation(existingAppointmentObject.locationID);
            }

            // Populate address fields - handle both old and new property names
            setAddress(existingAppointmentObject.location.address?.street || existingAppointmentObject.location.address?.addressLine1 || '');
            setAddress2(existingAppointmentObject.location.address?.street2 || existingAppointmentObject.location.address?.addressLine2 || '');
            setCity(existingAppointmentObject.location.address?.city || '');
            setState(existingAppointmentObject.location.address?.state || '');
            setZip(existingAppointmentObject.location.address?.zip || existingAppointmentObject.location.address?.postalCode || '');
            setCountry(existingAppointmentObject.location.address?.country || 'US');
            
            // Handle contacts - could be an array, single contact object, or nested in location
            if (existingAppointmentObject.contacts && Array.isArray(existingAppointmentObject.contacts) && existingAppointmentObject.contacts.length > 0) {
                // New structure: contacts array at root level
                const firstContact = existingAppointmentObject.contacts[0];
                setContact(firstContact.name || '');
                setTitle(firstContact.title || '');
                setPhone(firstContact.phone || firstContact.number || '');
                setEmail(firstContact.email || '');
                // Set selectedContact if the contact has an id to make fields read-only
                if (firstContact.id) {
                    setSelectedContact(firstContact);
                }
            } else if (existingAppointmentObject.contact) {
                // Current structure: single contact object at root level
                setContact(existingAppointmentObject.contact.name || '');
                setTitle(existingAppointmentObject.contact.title || '');
                setPhone(existingAppointmentObject.contact.number || existingAppointmentObject.contact.phone || '');
                setEmail(existingAppointmentObject.contact.email || '');
                // Set selectedContact if the contact has an id to make fields read-only
                if (existingAppointmentObject.contact.id) {
                    setSelectedContact(existingAppointmentObject.contact);
                }
            } else if (existingAppointmentObject.location?.contact) {
                // Old structure: single contact nested in location
                setContact(existingAppointmentObject.location.contact.name || '');
                setTitle(existingAppointmentObject.location.contact.title || '');
                setPhone(existingAppointmentObject.location.contact.phone || existingAppointmentObject.location.contact.number || '');
                setEmail(existingAppointmentObject.location.contact.email || '');
                // Set selectedContact if the contact has an id to make fields read-only
                if (existingAppointmentObject.location.contact.id) {
                    setSelectedContact(existingAppointmentObject.location.contact);
                }
            } else {
                // No contact info
                setContact('');
                setTitle('');
                setPhone('');
                setEmail('');
            }

            let adjustedStartTime, adjustedEndTime;
            
            // Handle new structure with scheduledStart
            if (existingAppointmentObject.scheduledStart) {
                // Extract time directly from ISO string to avoid timezone conversion
                const isoString = existingAppointmentObject.scheduledStart;
                const timePart = isoString.substring(11, 16); // Extract HH:MM
                const datePart = isoString.substring(0, 10); // Extract YYYY-MM-DD
                const [year, month, day] = datePart.split('-');
                setStartDate(new Date(parseInt(year), parseInt(month) - 1, parseInt(day)));
                setStartTime(timePart);
            }
            // Handle old structure with separate startDate and startTime
            else if (existingAppointmentObject.startDate && existingAppointmentObject.startTime) {
                // Extract date part from startDate (YYYY-MM-DD)
                const startDatePart = existingAppointmentObject.startDate.substring(0, 10);
                // Extract time part from startTime (HH:MM:SS+TZ)
                const startTimePart = existingAppointmentObject.startTime.substring(11);
                // Combine into single datetime string
                const combinedStartDateTime = `${startDatePart}T${startTimePart}`;
                
                // Create datetime object and subtract 4 hours
                const adjustedStartDateTime = new Date(combinedStartDateTime);
                adjustedStartDateTime.setHours(adjustedStartDateTime.getHours());
                
                // Set both date and time from adjusted datetime
                setStartDate(new Date(adjustedStartDateTime.getFullYear(), adjustedStartDateTime.getMonth(), adjustedStartDateTime.getDate()));
                adjustedStartTime = adjustedStartDateTime.toTimeString().substring(0, 5); // HH:MM format
                setStartTime(adjustedStartTime);
            } else {
                setStartDate(new Date());
                setStartTime('08:00');
            }
            
            // Handle new structure with scheduledEnd
            if (existingAppointmentObject.scheduledEnd) {
                // Extract time directly from ISO string to avoid timezone conversion
                const isoString = existingAppointmentObject.scheduledEnd;
                const timePart = isoString.substring(11, 16); // Extract HH:MM
                const datePart = isoString.substring(0, 10); // Extract YYYY-MM-DD
                const [year, month, day] = datePart.split('-');
                setEndDate(new Date(parseInt(year), parseInt(month) - 1, parseInt(day)));
                setEndTime(timePart);
            }
            // Handle old structure with separate endDate and endTime
            else if (existingAppointmentObject.endDate && existingAppointmentObject.endTime) {
                // Extract date part from endDate (YYYY-MM-DD)
                const endDatePart = existingAppointmentObject.endDate.substring(0, 10);
                // Extract time part from endTime (HH:MM:SS+TZ)
                const endTimePart = existingAppointmentObject.endTime.substring(11);
                // Combine into single datetime string
                const combinedEndDateTime = `${endDatePart}T${endTimePart}`;
                
                // Create datetime object and subtract 4 hours
                const adjustedEndDateTime = new Date(combinedEndDateTime);
                adjustedEndDateTime.setHours(adjustedEndDateTime.getHours());
                
                // Set both date and time from adjusted datetime
                setEndDate(new Date(adjustedEndDateTime.getFullYear(), adjustedEndDateTime.getMonth(), adjustedEndDateTime.getDate()));
                adjustedEndTime = adjustedEndDateTime.toTimeString().substring(0, 5); // HH:MM format
                setEndTime(adjustedEndTime);
            } else {
                setEndDate(new Date());
                setEndTime('17:00');
            };
        };
    }, [existingAppointmentObject]);

    useEffect(() => {
        if(appointmentType === 'New' || (appointmentType === 'Edit' && !selectedCustomer)){
            if (customerSearch.trim() === '') {
                setFilteredCustomers(customers);
            } else {
                const filtered = customers.filter(customer => 
                    customer.customerNumber.toLowerCase().includes(customerSearch.toLowerCase()) ||
                    customer.customerName.toLowerCase().includes(customerSearch.toLowerCase())
                );
                setFilteredCustomers(filtered);
            };
        }
        else if(appointmentType === 'Edit' && existingAppointmentObject && !selectedCustomer){
            const customer = customers.find(customer => customer.customerNumber === existingAppointmentObject.customerID);
            if (customer) {
                setSelectedCustomer(customer);
                setCustomer(`${customer.customerNumber} - ${customer.customerName}`);
            }
        };
    }, [customers, customerSearch, existingAppointmentObject, selectedCustomer]);

    useEffect(() => {
        if(appointmentType === 'New' || (appointmentType === 'Edit' && !selectedLocation)){
            if (customerLocationSearch === '') {
                setFilteredLocations(customerLocations);
            } else {
                const filtered = customerLocations.filter(location => {
                    const searchTerm = customerLocationSearch.toLowerCase();
                    
                    // Search in location name and ID
                    const nameMatch = location.locationName.toLowerCase().includes(searchTerm);
                    const idMatch = location.locationID.toString().toLowerCase().includes(searchTerm);
                    
                    // Search in address if it's an object
                    let addressMatch = false;
                    if (location.address && typeof location.address === 'object') {
                        const addressString = `${location.address.addressLine1 || ''} ${location.address.addressLine2 || ''} ${location.address.city || ''}, ${location.address.state || ''} ${location.address.postalCode || ''}`;
                        addressMatch = addressString.toLowerCase().includes(searchTerm);
                    } else if (typeof location.address === 'string') {
                        addressMatch = location.address.toLowerCase().includes(searchTerm);
                    }
                    
                    return nameMatch || idMatch || addressMatch;
                });
                setFilteredLocations(filtered);
            }
        }
    }, [customerLocations, customerLocationSearch, selectedCustomer, selectedLocation]);

    // Filter contacts based on search
    useEffect(() => {
        if (appointmentType === 'New' || (appointmentType === 'Edit' && !selectedContact)) {
            let contactsToFilter = [];
            
            // Try to get contacts from selectedLocation first
            if (selectedLocation && selectedLocation.contacts) {
                contactsToFilter = selectedLocation.contacts;
            } 
            // If selectedLocation doesn't have contacts (e.g., from existingAppointmentObject),
            // find the location in customerLocations array which has the full data
            else if (selectedLocation && customerLocations) {
                const fullLocation = customerLocations.find(loc => 
                    loc.locationID === (selectedLocation.locationID || selectedLocation.id)
                );
                if (fullLocation && fullLocation.contacts) {
                    contactsToFilter = fullLocation.contacts;
                }
            }
            
            if (contactsToFilter.length > 0) {
                if (contactSearch === '') {
                    setFilteredContacts(contactsToFilter);
                } else {
                    const filtered = contactsToFilter.filter(contact => {
                        const searchTerm = contactSearch.toLowerCase();
                        const nameMatch = contact.name?.toLowerCase().includes(searchTerm);
                        const emailMatch = contact.email?.toLowerCase().includes(searchTerm);
                        const phoneMatch = contact.number?.toLowerCase().includes(searchTerm);
                        return nameMatch || emailMatch || phoneMatch;
                    });
                    setFilteredContacts(filtered);
                }
            } else {
                setFilteredContacts([]);
            }
        }
    }, [selectedLocation, contactSearch, appointmentType, selectedContact, customerLocations]);

    // Filter previous appointments based on search
    useEffect(() => {
        if (previousAppointmentSearch === '') {
            setFilteredPreviousAppointments(previousAppointments);
        } else {
            const filtered = previousAppointments.filter(appointment => {
                const searchTerm = previousAppointmentSearch.toLowerCase();
                const idMatch = appointment.appointmentID?.toString().toLowerCase().includes(searchTerm);
                const descriptionMatch = appointment.description?.toLowerCase().includes(searchTerm);
                const typeMatch = appointment.type?.toLowerCase().includes(searchTerm);
                return idMatch || descriptionMatch || typeMatch;
            });
            setFilteredPreviousAppointments(filtered);
        }
    }, [previousAppointments, previousAppointmentSearch]);

    useEffect(() => {
        if(existingAppointmentObject && filteredTechnicians && selectedTechnicians.length < 1){
            let assignedTechs = [];
            // Check for new structure (technicians) or old structure (assignedTechnicians)
            const techniciansList = existingAppointmentObject.technicians || existingAppointmentObject.assignedTechnicians;
            
            if (techniciansList && Array.isArray(techniciansList)) {
                techniciansList.forEach(tech => {
                    // Match by id field - both new structures use id
                    const foundTech = filteredTechnicians.find(t => t.id === tech.id);
                    if(foundTech) {
                        assignedTechs.push(foundTech);
                    }
                });
            }
            setSelectedTechnicians(assignedTechs);
        };
    },[filteredTechnicians,existingAppointmentObject])

    useEffect(() => {
        const techniciansArray = Array.isArray(filteredTechnicians) 
            ? filteredTechnicians 
            : (filteredTechnicians && typeof filteredTechnicians === 'object') 
                ? Object.values(filteredTechnicians) 
                : [];

        console.log('filteredTechnicians:', filteredTechnicians);
        console.log('techniciansArray:', techniciansArray);
        console.log('technicianSearch:', technicianSearch);

        if (technicianSearch === '') {
            setSearchFilteredTechnicians(techniciansArray);
        } else {
            const searchTerm = technicianSearch.toLowerCase();
            const filtered = techniciansArray.filter(technician => {
                const nameMatch = technician.name?.toLowerCase().includes(searchTerm);
                const idMatch = technician.id?.toString().toLowerCase().includes(searchTerm);
                const emailMatch = technician.email?.toLowerCase().includes(searchTerm);
                
                return nameMatch || idMatch || emailMatch;
            });
            setSearchFilteredTechnicians(filtered);
        }
    }, [filteredTechnicians, technicianSearch]);

    const deleteAppointment = () => {
        if (window.confirm('Are you sure you want to delete this appointment? This action cannot be undone.')) {
            if (existingAppointmentObject && existingAppointmentObject.appointmentID) {
                deleteFSAppointment(
                    apiToken, 
                    existingAppointmentObject.appointmentID, 
                    () => {
                        // Success callback
                        if (refreshAppointments) {
                            refreshAppointments();
                        }
                        onClose();
                    },
                    (error) => {
                        // Error callback
                        alert(`Failed to delete appointment: ${error}`);
                    }
                );
            }
        }
    };

    const createAppointmentObject = () => {
        const appointmentObject = {
            appointmentID: existingAppointmentObject ? existingAppointmentObject.appointmentID : undefined,
            id: existingAppointmentObject ? existingAppointmentObject.id : undefined,
            // Basic Information
            startDate: startDate,
            endDate: endDate,
            startTime: startTime,
            endTime: endTime,
            type: type,
            
            // Customer & Project Information
            customer: selectedCustomer ? {
                id: selectedCustomer.id,
                customerNumber: selectedCustomer.customerNumber,
                customerName: selectedCustomer.customerName,
                customerClass: selectedCustomer.customerClass,
                status: selectedCustomer.status
            } : null,
            location: selectedLocation ? {
                id: selectedLocation.locationID,
                locationName: selectedLocation.locationName,
                address: selectedLocation.address,
                contact: selectedLocation.contact
            } : {
                locationName: customerLocationSearch,
                address: {
                    addressLine1: address,
                    addressLine2: address2,
                    city: city,
                    state: state,
                    zip: zip,
                    country: country
                }
            },
            project: project || null,
            projectId: project || null,
            
            // Contact Information
            contact: selectedContact ? {
                id: selectedContact.id,
                name: contact,
                title: title,
                phone: phone,
                email: email
            } : {
                name: contact,
                title: title,
                phone: phone,
                email: email
            },
            
            // Assignment & Options
            assignedTechnicians: selectedTechnicians.map(tech => ({
                id: tech.id,
                name: tech.name,
                email: tech.email,
                branch: tech.branch
            })),
            technicians: selectedTechnicians.map(tech => ({
                id: tech.id,
                name: tech.name,
                email: tech.email,
                branch: tech.branch
            })),

            // Related Appointment (optional)
            relatedAppointment: relatedAppointment || null,
            
            // Options
            notifyTechs: notifyTechs,
            requireFSR: requireFSR,
            autosendFSR: autosendFSR,
            multipleFSRs: (appointmentType !== 'Edit' && startDate.toISOString().split('T')[0] !== endDate.toISOString().split('T')[0]) ? multipleFSRs : false,
            notes: notes,
            pmChecklist: pmChecklist,
            fileShareLink: fileShareLink,
            appointmentDescription: appointmentDescription,
            
            // Override Settings
            overrideAddress: overrideAddress,
            overrideContact: overrideContact,
            createNewLocation: createNewLocation,
            createNewContact: createNewContact,
            
            // Branch Information
            branchSelected: branchSelected,
            branch: branchSelected,
            
            // Creation Metadata
            createdAt: new Date().toISOString(),
            createdBy: currentUser.email
        };

        submitAppointment(appointmentObject);
    };

    const BranchSelector = () => {
        return (
            <select 
                className="calendar-branch-select-input"
                value={branchSelected} 
                onChange={(e) => setBranchSelected(e.target.value)}
                >
                {branchOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        );
    };

    const appointmentBodyProps = {
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        startTime,
        setStartTime,
        endTime,
        setEndTime,
        type,
        setType,
        customer,
        setCustomer,
        project,
        setProject,
        location,
        setLocation,
        address,
        setAddress,
        address2,
        setAddress2,
        city,
        setCity,
        state,
        setState,
        zip,
        setZip,
        country,
        setCountry,
        contact,
        setContact,
        title,
        setTitle,
        phone,
        setPhone,
        email,
        setEmail,
        assignedTo,
        setAssignedTo,
        requireFSR,
        setRequireFSR,
        autosendFSR,
        setAutosendFSR,
        notes,
        setNotes,
        onClose,
        notifyTechs,
        setNotifyTechs,
        multipleFSRs,
        setMultipleFSRs,
        pmChecklist,
        setPmChecklist,
        fileShareLink,
        setFileShareLink,
        createAppointmentObject,
        deleteAppointment,
        customerSearch,
        setCustomerSearch,
        filteredCustomers,
        selectedCustomer,
        setSelectedCustomer,
        customerLocationSearch,
        setCustomerLocationSearch,
        filteredLocations,
        selectedLocation,
        setSelectedLocation,
        technicianSearch,
        setTechnicianSearch,
        searchFilteredTechnicians,
        selectedTechnicians,
        setSelectedTechnicians,
        overrideAddress,
        setOverrideAddress,
        overrideContact,
        setOverrideContact,
        createNewLocation,
        setCreateNewLocation,
        createNewContact,
        setCreateNewContact,
        token: apiToken,
        customers,
        customersLoading,
        setCustomerLocations,
        setCustomerLocationsError,
        appointmentDescription,
        setAppointmentDescription,
        createNewLocationToggle,
        setCreateNewLocationToggle,
        appointmentType,
        showCustomerDropdown, setShowCustomerDropdown,
        showLocationDropdown,setShowLocationDropdown,
        showTechnicianDropdown,setShowTechnicianDropdown,
        showContactDropdown, setShowContactDropdown,
        contactSearch, setContactSearch,
        filteredContacts,
        selectedContact, setSelectedContact,
        relatedAppointment, setRelatedAppointment,
        existingAppointmentObject,
        previousAppointments,
        showPreviousAppointmentsDropdown, setShowPreviousAppointmentsDropdown,
        previousAppointmentSearch, setPreviousAppointmentSearch,
        filteredPreviousAppointments,
        selectedPreviousAppointment, setSelectedPreviousAppointment,
        creatingNewCustomer, setCreatingNewCustomer,
        newCustomerNumber, setNewCustomerNumber,
        newCustomerName, setNewCustomerName,
        newCustomerClass, setNewCustomerClass,
        isReadOnly
    };

    return (
        <div className="field-service-modal-backdrop">
            <div className="field-service-modal-content">
                <div className="field-service-modal-header">
                    <h3 className="field-service-modal-title">
                        {isReadOnly ? 'View Appointment' : (appointmentType === 'Edit' ? 'Edit Appointment' : 'New Appointment')}
                    </h3>
                    <button className="field-service-modal-close-button" onClick={onClose}>
                        ×
                    </button>
                </div>
                <div className="field-service-modal-body">
                    {appointmentType === 'Edit' && !existingAppointmentObject ? (
                        <div className="field-service-loading-container">
                            <div className="field-service-loading-background"></div>
                            <div className="field-service-loading-animation">
                                <div className="field-service-spinner"></div>
                            </div>
                            <h3>Loading Appointment<span className="field-service-loading-dots"></span></h3>
                            <p>Please wait while we retrieve and prepare your appointment details for editing.</p>
                        </div>
                    ) : branchSelected === 'complete' && appointmentType === 'New' ? (
                        <div className="field-service-branch-selector-modal">
                            <h3>Select Branch</h3>
                            <p>Please select a specific branch to create an appointment.</p>
                            <BranchSelector />
                        </div>
                    ) : (
                        <AppointmentBody {...appointmentBodyProps} />
                    )}
                </div>
                
                {/* Loading Overlay */}
                {(appointmentLoading || appointmentSuccess || appointmentError) && (
                    <div className="field-service-loading-overlay">
                        <div className="field-service-loading-content">
                            {appointmentLoading && (
                                <>
                                    <div className="field-service-spinner"></div>
                                    <h3>Creating Appointment...</h3>
                                    <p>Please wait while we process your request.</p>
                                </>
                            )}
                            
                            {appointmentSuccess && !appointmentLoading && (
                                <>
                                    <div className="field-service-success-icon">✓</div>
                                    <h3>Success!</h3>
                                    <p>{appointmentSuccess}</p>
                                </>
                            )}
                            
                            {appointmentError && !appointmentLoading && (
                                <>
                                    <div className="field-service-error-icon">✕</div>
                                    <h3>Error</h3>
                                    <p>{appointmentError}</p>
                                </>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

const FSRComponent = ({ onClose }) => {
    return (
        <div className="field-service-modal-backdrop" onClick={onClose}>
            <div className="field-service-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="field-service-modal-header">
                    <h3 className="field-service-modal-title">New Field Service Report</h3>
                    <button className="field-service-modal-close-button" onClick={onClose}>
                        ×
                    </button>
                </div>
                <div className="field-service-modal-body">
                    <div className="field-service-modal-placeholder">
                        <h2>FSR Form</h2>
                        <p>Field Service Report creation form will be implemented here</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

const CalendarComponent = ({ filteredTechnicians, branchSelected, filteredAppointments, updateAppointment, rescheduleAppointment, currentUserBranch }) => {
    const [viewType, setViewType] = useState('month'); // 'week' or 'month'
    const [currentDate, setCurrentDate] = useState(new Date());
    const [minimizedTechnicians, setMinimizedTechnicians] = useState({});
    const [draggedAppointmentData, setDraggedAppointmentData] = useState(null);
    const [dropTargetKey, setDropTargetKey] = useState('');
    
    // Group technicians by branch
    const groupTechniciansByBranch = (techniciansObj) => {
        // Convert object to array first if it's an object
        const techniciansArray = techniciansObj && typeof techniciansObj === 'object' && !Array.isArray(techniciansObj)
            ? Object.values(techniciansObj)
            : techniciansObj || [];
            
        const grouped = techniciansArray.reduce((acc, tech) => {
            const branchId = tech.branch || tech.employeeSettings?.branchID || 'Unknown';
            if (!acc[branchId]) {
                acc[branchId] = [];
            }
            acc[branchId].push(tech);
            return acc;
        }, {});
        
        // Sort technicians within each branch by name
        Object.keys(grouped).forEach(branchId => {
            grouped[branchId].sort((a, b) => 
                (a.name || a.employeeName || '').localeCompare(b.name || b.employeeName || '')
            );
        });
        
        return grouped;
    };

    // Get branch name from branchId
    const getBranchName = (branchId) => {
        const branch = branchOptions.find(b => b.value === branchId);
        return branch ? branch.label : `Branch ${branchId}`;
    };

    // Generate calendar dates based on view type
    const getCalendarDates = () => {
        const dates = [];
        const startDate = new Date(currentDate);
        
        if (viewType === 'week') {
            // Get start of week (Sunday)
            const dayOfWeek = startDate.getDay();
            startDate.setDate(startDate.getDate() - dayOfWeek);
            
            // Generate 7 days
            for (let i = 0; i < 7; i++) {
                const date = new Date(startDate);
                date.setDate(startDate.getDate() + i);
                dates.push(date);
            }
        } else {
            // Month view
            const year = startDate.getFullYear();
            const month = startDate.getMonth();
            const monthStart = new Date(year, month, 1);
            const monthEnd = new Date(year, month + 1, 0);
            
            // Get first Sunday of the calendar
            const firstSunday = new Date(monthStart);
            firstSunday.setDate(firstSunday.getDate() - monthStart.getDay());
            
            // Generate dates to fill calendar grid (6 weeks)
            for (let i = 0; i < 42; i++) {
                const date = new Date(firstSunday);
                date.setDate(firstSunday.getDate() + i);
                dates.push(date);
            }
        }
        
        return dates;
    };

    // Navigation functions
    const navigatePrevious = () => {
        const newDate = new Date(currentDate);
        const today = new Date();
        
        if (viewType === 'week') {
            newDate.setDate(newDate.getDate() - 7);
            // Don't allow going before current week
            const currentWeekStart = new Date(today);
            currentWeekStart.setDate(today.getDate() - today.getDay());
            if (newDate < currentWeekStart) {
                return; // Don't navigate to past weeks
            }
        } else {
            newDate.setMonth(newDate.getMonth() - 1);
            // Don't allow going before current month
            const currentMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
            if (newDate < currentMonthStart) {
                return; // Don't navigate to past months
            }
        }
        setCurrentDate(newDate);
    };

    const navigateNext = () => {
        const newDate = new Date(currentDate);
        if (viewType === 'week') {
            newDate.setDate(newDate.getDate() + 7);
        } else {
            newDate.setMonth(newDate.getMonth() + 1);
        }
        setCurrentDate(newDate);
    };

    const navigateToday = () => {
        setCurrentDate(new Date());
    };

    // Quick selector for jumping to specific weeks/months
    const jumpToDate = (targetDate) => {
        setCurrentDate(new Date(targetDate));
    };

    // Generate quick selector options
    const getQuickSelectorOptions = () => {
        const options = [];
        const today = new Date();
        
        if (viewType === 'week') {
            // Generate next 12 months, jumping to first week of each month
            for (let i = 0; i < 12; i++) {
                const monthStart = new Date(today.getFullYear(), today.getMonth() + i, 1);
                // Find the first Sunday of the month (or the Sunday before if month doesn't start on Sunday)
                const firstWeekStart = new Date(monthStart);
                firstWeekStart.setDate(monthStart.getDate() - monthStart.getDay());
                
                options.push({
                    value: firstWeekStart.toISOString(),
                    label: monthStart.toLocaleDateString('en-US', { month: 'long', year: 'numeric' }),
                    date: firstWeekStart
                });
            }
        } else {
            // Generate next 12 months
            for (let i = 0; i < 12; i++) {
                const monthStart = new Date(today.getFullYear(), today.getMonth() + i, 1);
                options.push({
                    value: monthStart.toISOString(),
                    label: monthStart.toLocaleDateString('en-US', { month: 'long', year: 'numeric' }),
                    date: monthStart
                });
            }
        }
        
        return options;
    };

    // Format date for display
    const formatDate = (date) => {
        return date.toLocaleDateString('en-US', { 
            weekday: viewType === 'week' ? 'long' : 'short',
            month: 'short', 
            day: 'numeric',
            year: viewType === 'month' ? undefined : 'numeric'
        });
    };

    // Get current period string
    const getCurrentPeriodString = () => {
        if (viewType === 'week') {
            const dates = getCalendarDates();
            const start = dates[0];
            const end = dates[6];
            return `${start.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} - ${end.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`;
        } else {
            return currentDate.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
        }
    };

    // Get appointments for a specific technician and date
    const getAppointmentsForDate = (technicianId, date) => {
        if (!filteredAppointments || !filteredAppointments[technicianId]) {
            return [];
        }

        const technicianAppointments = filteredAppointments[technicianId].appointments || {};
        const appointments = [];

        Object.values(technicianAppointments).forEach(appointment => {
            const startDate = new Date(appointment.scheduledStart || appointment.scheduledStartUTC);
            const endDate = new Date(appointment.scheduledEnd || appointment.scheduledEndUTC);
            
            // Create date objects for comparison (set to midnight to compare dates only)
            const appointmentStartDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
            const appointmentEndDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
            const targetDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            
            // Check if the appointment falls on this date
            // Include appointment if target date is between start and end dates (inclusive)
            if (targetDate >= appointmentStartDate && targetDate <= appointmentEndDate) {
                appointments.push(appointment);
            }
        });

        return appointments;
    };

    // Get all appointments for all technicians for a specific date
    const getAllAppointmentsForDate = (date) => {
        const allAppointments = [];

        if (!filteredAppointments) {
            return [];
        }

        // Iterate through all technicians
        Object.entries(filteredAppointments).forEach(([technicianId, techData]) => {
            const technicianAppointments = techData.appointments || {};
            const technicianName = techData.name || techData.employeeName || 'Unknown';

            Object.values(technicianAppointments).forEach(appointment => {
                const startDate = new Date(appointment.scheduledStart || appointment.scheduledStartUTC);
                const endDate = new Date(appointment.scheduledEnd || appointment.scheduledEndUTC);
                
                // Create date objects for comparison (set to midnight to compare dates only)
                const appointmentStartDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
                const appointmentEndDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
                const targetDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                
                // Check if the appointment falls on this date
                // Include appointment if target date is between start and end dates (inclusive)
                if (targetDate >= appointmentStartDate && targetDate <= appointmentEndDate) {
                    allAppointments.push({
                        ...appointment,
                        technicianName: technicianName,
                        technicianId: technicianId,
                        technicianBranch: techData.branch || techData.employeeSettings?.branchID || null
                    });
                }
            });
        });

        return allAppointments;
    };

    // Format appointment time for display
    const formatAppointmentTime = (startDate, endDate) => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        
        const startTime = start.toLocaleTimeString('en-US', { 
            hour: 'numeric', 
            minute: '2-digit',
            hour12: true 
        });
        
        const endTime = end.toLocaleTimeString('en-US', { 
            hour: 'numeric', 
            minute: '2-digit',
            hour12: true 
        });
        
        return `${startTime} - ${endTime}`;
    };

    const buildDropTargetKey = (targetDate, targetTechnicianId = 'all') => {
        const dateKey = new Date(targetDate).toISOString().split('T')[0];
        return `${targetTechnicianId}-${dateKey}`;
    };

    const normalizeBranchId = (branchId) => (branchId == null ? '' : String(branchId));

    const getAppointmentBranchId = (appointment, fallbackBranchId = null) => {
        return appointment?.branch
            ?? appointment?.branchID
            ?? appointment?.branchId
            ?? appointment?.location?.branch
            ?? appointment?.location?.branchID
            ?? appointment?.location?.branchId
            ?? appointment?.customer?.branch
            ?? appointment?.customer?.branchID
            ?? appointment?.customer?.branchId
            ?? fallbackBranchId;
    };

    const isUserBranchAppointment = (appointment, fallbackBranchId = null) => {
        const appointmentBranchId = normalizeBranchId(getAppointmentBranchId(appointment, fallbackBranchId));
        const userBranchId = normalizeBranchId(currentUserBranch);

        // If branch data is unavailable, keep editable to avoid accidental lockout.
        if (!appointmentBranchId || !userBranchId) return true;

        return appointmentBranchId === userBranchId;
    };

    const handleAppointmentDragStart = (event, appointment, technicianId = null) => {
        event.dataTransfer.effectAllowed = 'move';
        setDraggedAppointmentData({
            appointment,
            sourceTechnicianId: technicianId
        });
    };

    const handleAppointmentDragEnd = () => {
        setDraggedAppointmentData(null);
        setDropTargetKey('');
    };

    const handleDateDragOver = (event, targetDate, targetTechnicianId = null) => {
        event.preventDefault();
        event.dataTransfer.dropEffect = 'move';
        setDropTargetKey(buildDropTargetKey(targetDate, targetTechnicianId || 'all'));
    };

    const handleDateDragLeave = (event, targetDate, targetTechnicianId = null) => {
        event.preventDefault();
        const targetKey = buildDropTargetKey(targetDate, targetTechnicianId || 'all');
        if (dropTargetKey === targetKey) {
            setDropTargetKey('');
        }
    };

    const handleDateDrop = async (event, targetDate, targetTechnicianId = null) => {
        event.preventDefault();
        setDropTargetKey('');

        if (!draggedAppointmentData || !rescheduleAppointment) return;

        // Week view drop targets are technician specific; block cross-tech drag/drop.
        if (targetTechnicianId && draggedAppointmentData.sourceTechnicianId && targetTechnicianId !== draggedAppointmentData.sourceTechnicianId) {
            setDraggedAppointmentData(null);
            return;
        }

        await rescheduleAppointment(draggedAppointmentData.appointment, targetDate);
        setDraggedAppointmentData(null);
    };

    const calendarDates = getCalendarDates();
    const groupedTechnicians = groupTechniciansByBranch(filteredTechnicians);
    
    // Check if we're at the current week/month (disable previous button)
    const isAtCurrentPeriod = () => {
        const today = new Date();
        if (viewType === 'week') {
            const currentWeekStart = new Date(today);
            currentWeekStart.setDate(today.getDate() - today.getDay());
            const viewWeekStart = new Date(currentDate);
            viewWeekStart.setDate(currentDate.getDate() - currentDate.getDay());
            return currentWeekStart.toDateString() === viewWeekStart.toDateString();
        } else {
            return currentDate.getMonth() === today.getMonth() && 
                   currentDate.getFullYear() === today.getFullYear();
        }
    };
    
    return (
        <div className="field-service-calendar">
            {/* Calendar Header */}
            <div className="calendar-header">
                <div className="calendar-header-left">
                    <h2 className="calendar-title">Technician Schedule</h2>
                    <div className="calendar-period">{getCurrentPeriodString()}</div>
                </div>
                
                <div className="calendar-header-center">
                    <div className="calendar-navigation">
                        <button 
                            className={`calendar-nav-button ${isAtCurrentPeriod() ? 'disabled' : ''}`} 
                            onClick={navigatePrevious}
                            disabled={isAtCurrentPeriod()}
                        >
                            ‹
                        </button>
                        <button className="calendar-today-button" onClick={navigateToday}>
                            Today
                        </button>
                        <button className="calendar-nav-button" onClick={navigateNext}>
                            ›
                        </button>
                    </div>
                    
                    {/* Quick Date Selector */}
                    <div className="calendar-quick-selector">
                        <select 
                            className="calendar-quick-select"
                            value={getQuickSelectorOptions().find(opt => {
                                const optDate = new Date(opt.value);
                                if (viewType === 'week') {
                                    // For week view, find the month that contains the current week
                                    const currentWeekStart = new Date(currentDate);
                                    currentWeekStart.setDate(currentDate.getDate() - currentDate.getDay());
                                    
                                    // Check if the current week falls within this month's range
                                    const monthStart = new Date(optDate.getFullYear(), optDate.getMonth(), 1);
                                    const monthEnd = new Date(optDate.getFullYear(), optDate.getMonth() + 1, 0);
                                    
                                    return currentWeekStart >= new Date(monthStart.getFullYear(), monthStart.getMonth(), 1 - monthStart.getDay()) &&
                                           currentWeekStart <= monthEnd;
                                } else {
                                    // Compare month/year
                                    return optDate.getMonth() === currentDate.getMonth() && 
                                           optDate.getFullYear() === currentDate.getFullYear();
                                }
                            })?.value || getQuickSelectorOptions()[0]?.value}
                            onChange={(e) => jumpToDate(e.target.value)}
                        >
                            {getQuickSelectorOptions().map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                
                <div className="calendar-header-right">
                    <div className="calendar-view-toggle">
                        <button 
                            className={`calendar-view-button ${viewType === 'week' ? 'active' : ''}`}
                            onClick={() => setViewType('week')}
                        >
                            Week
                        </button>
                        <button 
                            className={`calendar-view-button ${viewType === 'month' ? 'active' : ''}`}
                            onClick={() => setViewType('month')}
                        >
                            Month
                        </button>
                    </div>
                </div>
            </div>

            {/* Calendar Grid */}
            {viewType === 'week' ? (
                <div className={`calendar-grid ${viewType}`}>
                    {/* Date Headers for Week View */}
                    <div className="calendar-dates-header">
                        <div className="calendar-technician-column-header">Technicians</div>
                        {calendarDates.map((date, index) => (
                            <div key={index} className={`calendar-date-header ${date.toDateString() === new Date().toDateString() ? 'today' : ''}`}>
                                {formatDate(date)}
                            </div>
                        ))}
                    </div>

                    {/* Technician Rows by Branch for Week View */}
                    <div className="calendar-technician-rows">
                        {Object.entries(groupedTechnicians).map(([branchId, technicians]) => (
                            <div key={branchId} className="calendar-branch-group">
                                {branchSelected === 'complete' && (
                                    <div className="calendar-branch-header">
                                        <div className="calendar-branch-name">{getBranchName(branchId)}</div>
                                        <div className="calendar-branch-divider"></div>
                                    </div>
                                )}
                                
                                {technicians.map((tech) => (
                                    <div key={tech.employeeID || tech.id} className="calendar-technician-row">
                                        <div className="calendar-technician-info">
                                            <div className="calendar-technician-name">
                                                {tech.name || tech.employeeName || 'Unknown'}
                                            </div>
                                            <div className="calendar-technician-email">
                                                {tech.email || 'N/A'}
                                            </div>
                                        </div>
                                        
                                        {calendarDates.map((date, dateIndex) => {
                                            const appointments = getAppointmentsForDate(tech.id || tech.employeeID, date);
                                            const currentTechnicianId = tech.id || tech.employeeID;
                                            const targetKey = buildDropTargetKey(date, currentTechnicianId);
                                            
                                            return (
                                                <div 
                                                    key={dateIndex} 
                                                    className={`calendar-day-cell ${date.toDateString() === new Date().toDateString() ? 'today' : ''}`}
                                                    onDragOver={(event) => handleDateDragOver(event, date, currentTechnicianId)}
                                                    onDragLeave={(event) => handleDateDragLeave(event, date, currentTechnicianId)}
                                                    onDrop={(event) => handleDateDrop(event, date, currentTechnicianId)}
                                                >
                                                    <div className={`calendar-day-content ${dropTargetKey === targetKey ? 'drop-target' : ''}`}>
                                                        {appointments.map((appointment, apptIndex) => {
                                                            const startDate = appointment.scheduledStart || appointment.scheduledStartDate;
                                                            const endDate = appointment.scheduledEnd || appointment.scheduledEndDate;
                                                            const customerName = appointment.customer?.customerName || appointment.customerName || 'N/A';
                                                            const locationName = appointment.location?.locationName || (typeof appointment.location === 'string' ? appointment.location : 'N/A');
                                                            const technicianBranchId = tech.branch || tech.employeeSettings?.branchID || null;
                                                            const canEditAppointment = isUserBranchAppointment(appointment, technicianBranchId);
                                                            const appointmentIdentifier = appointment.appointmentNbr || appointment.appointmentID;
                                                            
                                                            return (
                                                                <div 
                                                                    key={appointment.appointmentID || appointment.appointmentNbr || apptIndex} 
                                                                    className={`calendar-appointment status-${getAppointmentStatusClassName(appointment.status)} ${canEditAppointment ? '' : 'read-only'}`}
                                                                    title={`${new Date(startDate).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })} - ${new Date(endDate).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })}\n${customerName} - ${locationName}\n${appointment.description || ''}`}
                                                                    draggable={canEditAppointment}
                                                                    onDragStart={(event) => canEditAppointment && handleAppointmentDragStart(event, appointment, currentTechnicianId)}
                                                                    onDragEnd={handleAppointmentDragEnd}
                                                                    onClick={() => updateAppointment(appointmentIdentifier, !canEditAppointment)}
                                                                    style={!canEditAppointment ? { backgroundColor: '#d3d3d3', color: '#000000', borderColor: '#9a9a9a', cursor: 'default' } : undefined}
                                                                >
                                                                    <div className="calendar-appointment-description">
                                                                        {appointment.description || 'No Description'}
                                                                    </div>
                                                                    <div className="calendar-appointment-customer">
                                                                        {customerName}
                                                                    </div>
                                                                    <div className="calendar-appointment-location">
                                                                        {locationName}
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                /* Month View - Single Calendar with All Appointments */
                <div className="calendar-month-unified">
                    {/* Weekday Headers */}
                    <div className="calendar-month-weekdays-unified">
                        {['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map((day, index) => (
                            <div key={index} className="calendar-month-weekday-unified">{day}</div>
                        ))}
                    </div>
                    
                    {/* Calendar Grid - All Appointments */}
                    <div className="calendar-month-grid-unified">
                        {calendarDates.map((date, dateIndex) => {
                            const isCurrentMonth = date.getMonth() === currentDate.getMonth();
                            const isToday = date.toDateString() === new Date().toDateString();
                            const appointments = getAllAppointmentsForDate(date);
                            const targetKey = buildDropTargetKey(date);
                            
                            return (
                                <div 
                                    key={dateIndex} 
                                    className={`calendar-month-date-unified ${isCurrentMonth ? 'current-month' : 'other-month'} ${isToday ? 'today' : ''} ${appointments.length > 0 ? 'has-appointments' : ''}`}
                                >
                                    <div className="calendar-month-date-header-unified">
                                        <span className="calendar-month-date-number-unified">
                                            {date.getDate()}
                                        </span>
                                    </div>
                                    <div
                                        className={`calendar-month-date-content-unified ${dropTargetKey === targetKey ? 'drop-target' : ''}`}
                                        onDragOver={(event) => handleDateDragOver(event, date)}
                                        onDragLeave={(event) => handleDateDragLeave(event, date)}
                                        onDrop={(event) => handleDateDrop(event, date)}
                                    >
                                        {appointments.map((appointment, apptIndex) => {
                                            const startDate = appointment.scheduledStart || appointment.scheduledStartDate;
                                            const customerName = appointment.customer?.customerName || appointment.customerName || 'N/A';
                                            const locationName = appointment.location?.locationName || (typeof appointment.location === 'string' ? appointment.location : 'N/A');
                                            const canEditAppointment = isUserBranchAppointment(appointment, appointment.technicianBranch);
                                            const appointmentIdentifier = appointment.appointmentNbr || appointment.appointmentID;
                                            
                                            return (
                                                <div 
                                                    key={appointment.appointmentID || appointment.appointmentNbr || apptIndex} 
                                                    className={`calendar-appointment-unified status-${getAppointmentStatusClassName(appointment.status)} ${canEditAppointment ? '' : 'read-only'}`}
                                                    title={`${appointment.technicianName}\n${new Date(startDate).toLocaleDateString()} ${new Date(startDate).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })}\n${customerName} - ${locationName}\n${appointment.description || ''}`}
                                                    draggable={canEditAppointment}
                                                    onDragStart={(event) => canEditAppointment && handleAppointmentDragStart(event, appointment, appointment.technicianId)}
                                                    onDragEnd={handleAppointmentDragEnd}
                                                    onClick={() => updateAppointment(appointmentIdentifier, !canEditAppointment)}
                                                    style={!canEditAppointment ? { backgroundColor: '#d3d3d3', color: '#000000', borderColor: '#9a9a9a', cursor: 'default' } : undefined}
                                                >
                                                    <div className="calendar-appointment-technician-unified">
                                                        {appointment.technicianName}
                                                    </div>
                                                    <div className="calendar-appointment-description-unified">
                                                        {appointment.description || 'No Description'}
                                                    </div>
                                                    <div className="calendar-appointment-customer-unified">
                                                        {customerName}
                                                    </div>
                                                    <div className="calendar-appointment-location-unified">
                                                        {locationName}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

            {/* No Technicians Message */}
            {(!filteredTechnicians || Object.keys(filteredTechnicians).length === 0) && (
                <div className="calendar-no-data">
                    <h3>No Technicians Found</h3>
                    <p>No technicians are available for the selected branch.</p>
                </div>
            )}
        </div>
    );
};

const FSRListComponent = ({ branchSelected, refreshToken = 0 }) => {
    const contextObject = useContext(Context);
    const [pastAppointments, setPastAppointments] = useState([]);
    const [filteredAppointments, setFilteredAppointments] = useState([]);
    const [selectedAppointment, setSelectedAppointment] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [recreateFSRLoading, setRecreateFSRLoading] = useState(false);
    const [recreateFSRError, setRecreateFSRError] = useState(null);
    const [attachmentDownloadLoading, setAttachmentDownloadLoading] = useState('');
    const [attachmentDownloadError, setAttachmentDownloadError] = useState(null);
    const [editingComments, setEditingComments] = useState(false);
    const [commentsEditValue, setCommentsEditValue] = useState('');
    const [commentsUpdateLoading, setCommentsUpdateLoading] = useState(false);
    const [commentsUpdateError, setCommentsUpdateError] = useState(null);

    // Filter states
    const [appointmentNumberFilter, setAppointmentNumberFilter] = useState('');
    const [typeFilter, setTypeFilter] = useState('');
    const [customerFilter, setCustomerFilter] = useState('');
    const [locationFilter, setLocationFilter] = useState('');
    const [technicianFilter, setTechnicianFilter] = useState('');
    const [projectNumberFilter, setProjectNumberFilter] = useState('');
    const [createdByFilter, setCreatedByFilter] = useState('');
    const [fromDateFilter, setFromDateFilter] = useState('');
    const [toDateFilter, setToDateFilter] = useState('');

    console.log(selectedAppointment)

    // Dropdown data
    const [customersAndLocations, setCustomersAndLocations] = useState([]);
    const [technicians, setTechnicians] = useState([]);

    // Fetch customers, locations, and technicians on mount
    useEffect(() => {
        if (contextObject.apiToken) {
            fetchCustomerAndLocations(contextObject.apiToken, setCustomersAndLocations, setError);
            getAllServiceTechnicians(contextObject.apiToken, setTechnicians, setError);
        }
    }, [contextObject.apiToken]);

    // Fetch past appointments with filters
    const fetchPastAppointments = async (filterValues = {}) => {
        if (!contextObject.apiToken) return;
        
        setLoading(true);
        const filterObject = {
            appointmentNumber: (filterValues.appointmentNumberFilter ?? appointmentNumberFilter) || null,
            type: (filterValues.typeFilter ?? typeFilter) || null,
            customer: (filterValues.customerFilter ?? customerFilter) || null,
            location: (filterValues.locationFilter ?? locationFilter) || null,
            techEmail: (filterValues.technicianFilter ?? technicianFilter) || null,
            projectNumber: (filterValues.projectNumberFilter ?? projectNumberFilter) || null,
            createdBy: (filterValues.createdByFilter ?? createdByFilter) || null,
            fromDate: (filterValues.fromDateFilter ?? fromDateFilter) || null,
            toDate: (filterValues.toDateFilter ?? toDateFilter) || null,
        };

        // Add branch filter if not 'complete' (All Branches)
        if (branchSelected && branchSelected !== 'complete') {
            filterObject.branch = parseInt(branchSelected);
        }

        await getPastAppointments(contextObject.apiToken, filterObject, setPastAppointments, setError);
        setLoading(false);
    };

    // Refetch when branch changes or filters change, debounced to preserve input focus while typing.
    useEffect(() => {
        if (!contextObject.apiToken) return;

        const debounceTimeout = setTimeout(() => {
            fetchPastAppointments({
                appointmentNumberFilter,
                typeFilter,
                customerFilter,
                locationFilter,
                technicianFilter,
                projectNumberFilter,
                createdByFilter,
                fromDateFilter,
                toDateFilter,
            });
        }, 300);

        return () => clearTimeout(debounceTimeout);
    }, [
        contextObject.apiToken,
        branchSelected,
        appointmentNumberFilter,
        typeFilter,
        customerFilter,
        locationFilter,
        technicianFilter,
        projectNumberFilter,
        createdByFilter,
        fromDateFilter,
        toDateFilter,
        refreshToken,
    ]);

    // Apply client-side type filter fallback in case backend does not filter by type.
    useEffect(() => {
        if (typeFilter) {
            setFilteredAppointments(
                pastAppointments.filter((appointment) => appointment.type === typeFilter)
            );
        } else {
            setFilteredAppointments(pastAppointments);
        }
    }, [pastAppointments, typeFilter]);

    // Reset comment editing state when selected appointment changes
    useEffect(() => {
        setEditingComments(false);
        setCommentsEditValue('');
        setCommentsUpdateError(null);
    }, [selectedAppointment?.appointmentID]);

    // Get all unique locations from selected customer
    const getLocationsForCustomer = () => {
        if (!customerFilter) return [];
        const customer = customersAndLocations.find(c => c.id === parseInt(customerFilter));
        return customer ? customer.locations : [];
    };

    // Handle filter reset
    const handleResetFilters = () => {
        setAppointmentNumberFilter('');
        setTypeFilter('');
        setCustomerFilter('');
        setLocationFilter('');
        setTechnicianFilter('');
        setProjectNumberFilter('');
        setCreatedByFilter('');
        setFromDateFilter('');
        setToDateFilter('');
    };

    // Get appointment type label
    const getTypeLabel = (type) => {
        const option = appointmentTypeOptions.find(opt => opt.value === type);
        return option ? option.label : type;
    };

    // Get branch label
    const getBranchLabel = (branch) => {
        const option = branchOptions.find(opt => opt.value === branch);
        return option ? option.label : branch;
    };

    const handleRecreateFSR = async () => {
        if (!contextObject.apiToken || (!selectedAppointment?.appointmentNbr && !selectedAppointment?.appointmentID)) {
            setRecreateFSRError('Missing token or appointment ID.');
            return;
        }

        setRecreateFSRLoading(true);
        setRecreateFSRError(null);

        try {
            const appointmentIdentifier = selectedAppointment.appointmentNbr || selectedAppointment.appointmentID;
            const fsr = await recreateFSR(contextObject.apiToken, appointmentIdentifier);

            if (!fsr) {
                setRecreateFSRError('FSR was recreated, but no FSR filename was returned.');
                return;
            }

            const completedFSR = await getCompletedFSR(contextObject.apiToken, fsr);
            if (!completedFSR) {
                setRecreateFSRError('FSR was recreated, but the PDF could not be downloaded.');
                return;
            }

            const pdfBlob = completedFSR instanceof Blob
                ? completedFSR
                : new Blob([completedFSR], { type: 'application/pdf' });

            const downloadUrl = window.URL.createObjectURL(pdfBlob);
            const downloadLink = document.createElement('a');
            downloadLink.href = downloadUrl;
            downloadLink.download = `${fsr}.pdf`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            window.URL.revokeObjectURL(downloadUrl);
        } catch (err) {
            setRecreateFSRError(err?.message || 'Error recreating FSR');
        } finally {
            setRecreateFSRLoading(false);
        }
    };

    const oacMeetingValue = selectedAppointment
        ? Boolean(selectedAppointment.oacMeeting ?? selectedAppointment.oacMeetingLink)
        : false;
    const safetyMeetingValue = selectedAppointment
        ? Boolean(selectedAppointment.safetyMeeting)
        : false;
    const hasActiveFilters = Boolean(
        appointmentNumberFilter ||
        typeFilter ||
        customerFilter ||
        locationFilter ||
        technicianFilter ||
        projectNumberFilter ||
        createdByFilter ||
        fromDateFilter ||
        toDateFilter
    );

    const handleDownloadAttachment = async (attachment) => {
        if (!contextObject.apiToken || !attachment?.filename) {
            setAttachmentDownloadError('Missing token or attachment filename.');
            return;
        }

        setAttachmentDownloadLoading(attachment.filename);
        setAttachmentDownloadError(null);

        try {
            const attachmentFile = await fetchAttachment(contextObject.apiToken, attachment.filename);
            if (!attachmentFile) {
                throw new Error('Attachment file could not be downloaded.');
            }

            const fileBlob = attachmentFile instanceof Blob
                ? attachmentFile
                : new Blob([attachmentFile]);

            const downloadUrl = window.URL.createObjectURL(fileBlob);
            const downloadLink = document.createElement('a');
            downloadLink.href = downloadUrl;
            downloadLink.download = attachment.oldFilename || attachment.filename;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            window.URL.revokeObjectURL(downloadUrl);
        } catch (err) {
            setAttachmentDownloadError(err?.message || 'Error downloading attachment');
        } finally {
            setAttachmentDownloadLoading('');
        }
    };

    const handleUpdateAdditionalComments = async () => {
        if (!contextObject.apiToken || !selectedAppointment) return;
        const appointmentIdentifier = selectedAppointment.appointmentNbr || selectedAppointment.appointmentID;
        if (!appointmentIdentifier) return;

        setCommentsUpdateLoading(true);
        setCommentsUpdateError(null);

        try {
            await FieldServiceAPI.updateAdditionalComments(contextObject.apiToken, appointmentIdentifier, commentsEditValue);
            setSelectedAppointment(prev => ({ ...prev, additionalComments: commentsEditValue }));
            setEditingComments(false);
            await fetchPastAppointments();
        } catch (err) {
            setCommentsUpdateError(err?.message || 'Error updating comments');
        } finally {
            setCommentsUpdateLoading(false);
        }
    };

    return (
        <div className="fsr-list-container">
            {/* Top Toolbar */}
            <div className="fsr-list-toolbar">
                <div className="fsr-list-filters">
                    <div className="fsr-filter-group">
                        <label>Appointment Number</label>
                        <input 
                            type="text" 
                            value={appointmentNumberFilter} 
                            onChange={(e) => setAppointmentNumberFilter(e.target.value)}
                            className="fsr-filter-input"
                            placeholder="Enter appointment number"
                        />
                    </div>

                    <div className="fsr-filter-group">
                        <label>Type</label>
                        <select
                            value={typeFilter}
                            onChange={(e) => setTypeFilter(e.target.value)}
                            className="fsr-filter-select"
                        >
                            <option value="">All Types</option>
                            {appointmentTypeOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="fsr-filter-group">
                        <label>Customer</label>
                        <select 
                            value={customerFilter} 
                            onChange={(e) => {
                                setCustomerFilter(e.target.value);
                                setLocationFilter(''); // Reset location when customer changes
                            }}
                            className="fsr-filter-select"
                        >
                            <option value="">All Customers</option>
                            {customersAndLocations.map((customer) => (
                                <option key={customer.id} value={customer.id}>
                                    {customer.customerName} ({customer.customerNumber})
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="fsr-filter-group">
                        <label>Location</label>
                        <select 
                            value={locationFilter} 
                            onChange={(e) => setLocationFilter(e.target.value)}
                            className="fsr-filter-select"
                            disabled={!customerFilter}
                        >
                            <option value="">All Locations</option>
                            {getLocationsForCustomer().map((location) => (
                                <option key={location.locationID} value={location.locationID}>
                                    {location.locationName}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="fsr-filter-group">
                        <label>Technician</label>
                        <select 
                            value={technicianFilter} 
                            onChange={(e) => setTechnicianFilter(e.target.value)}
                            className="fsr-filter-select"
                        >
                            <option value="">All Technicians</option>
                            {technicians.map((tech) => (
                                <option key={tech.id} value={tech.email}>
                                    {tech.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="fsr-filter-group">
                        <label>Project Number</label>
                        <input
                            type="text"
                            value={projectNumberFilter}
                            onChange={(e) => setProjectNumberFilter(e.target.value)}
                            className="fsr-filter-input"
                            placeholder="Enter project number"
                        />
                    </div>

                    <div className="fsr-filter-group">
                        <label>Created By</label>
                        <input
                            type="text"
                            value={createdByFilter}
                            onChange={(e) => setCreatedByFilter(e.target.value)}
                            className="fsr-filter-input"
                            placeholder="Enter creator email"
                        />
                    </div>

                    <div className="fsr-filter-group">
                        <label>From Date</label>
                        <input 
                            type="date" 
                            value={fromDateFilter} 
                            onChange={(e) => setFromDateFilter(e.target.value)}
                            className="fsr-filter-input"
                        />
                    </div>

                    <div className="fsr-filter-group">
                        <label>To Date</label>
                        <input 
                            type="date" 
                            value={toDateFilter} 
                            onChange={(e) => setToDateFilter(e.target.value)}
                            className="fsr-filter-input"
                        />
                    </div>

                    <div className="fsr-filter-actions">
                        {hasActiveFilters && (
                            <button 
                                onClick={handleResetFilters}
                                className="fsr-filter-button secondary"
                                disabled={loading}
                            >
                                Clear Filters
                            </button>
                        )}
                    </div>
                </div>
            </div>

            {/* Main Content Area */}
            <div className="fsr-list-content">
                {/* Left Sidebar - Appointment List */}
                <div className="fsr-list-sidebar">
                    {loading && (
                        <div className="fsr-list-loading">Loading appointments...</div>
                    )}
                    {error && (
                        <div className="fsr-list-error">{error}</div>
                    )}
                    {!loading && filteredAppointments.length === 0 && (
                        <div className="fsr-list-empty">No completed appointments found</div>
                    )}
                    {!loading && filteredAppointments.length > 0 && (
                        <div className="fsr-appointment-tiles">
                            {filteredAppointments.map((appointment) => (
                                <div 
                                    key={appointment.appointmentID}
                                    className={`fsr-appointment-tile ${selectedAppointment?.appointmentID === appointment.appointmentID ? 'selected' : ''}`}
                                    onClick={() => setSelectedAppointment(appointment)}
                                >
                                    <div className="fsr-tile-header">
                                        <span className="fsr-tile-id">{appointment.appointmentNbr}</span>
                                        <span className="fsr-tile-type">{getTypeLabel(appointment.type)}</span>
                                    </div>
                                    <div className="fsr-tile-branch">
                                        {getBranchLabel(appointment.branch)}
                                    </div>
                                    <div className="fsr-tile-description">
                                        {appointment.description || 'No description'}
                                    </div>
                                    <div className="fsr-tile-customer">
                                        {appointment.customer?.customerName || 'N/A'}
                                    </div>
                                    <div className="fsr-tile-location">
                                        {appointment.location?.locationName || 'N/A'}
                                    </div>
                                    <div className="fsr-tile-technicians">
                                        {appointment.technicians && appointment.technicians.length > 0 
                                            ? appointment.technicians.map(tech => tech.name).join(', ')
                                            : 'No technicians assigned'}
                                    </div>
                                    <div className="fsr-tile-date">
                                        {new Date(appointment.scheduledStart).toLocaleDateString()}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Right Panel - Appointment Details */}
                <div className="fsr-detail-panel">
                    {!selectedAppointment ? (
                        <div className="fsr-detail-empty">
                            Select an appointment to view details
                        </div>
                    ) : (
                        <div className="fsr-detail-content">
                            <h2 className="fsr-detail-title">Appointment Details</h2>
                            
                            <div className="fsr-detail-section">
                                <h3>Basic Information</h3>
                                <div className="fsr-detail-grid">
                                    <div className="fsr-detail-item">
                                        <label>Appointment Number:</label>
                                        <span>{selectedAppointment.appointmentNbr}</span>
                                    </div>
                                    <div className="fsr-detail-item">
                                        <label>Type:</label>
                                        <span>{getTypeLabel(selectedAppointment.type)}</span>
                                    </div>
                                    <div className="fsr-detail-item">
                                        <label>Branch:</label>
                                        <span>{getBranchLabel(selectedAppointment.branch)}</span>
                                    </div>
                                    <div className="fsr-detail-item">
                                        <label>Status:</label>
                                        <span>{getNormalizedAppointmentStatus(selectedAppointment.status)}</span>
                                    </div>
                                    <div className="fsr-detail-item">
                                        <label>Description:</label>
                                        <span>{selectedAppointment.description || 'N/A'}</span>
                                    </div>
                                    <div className="fsr-detail-item">
                                        <label>Project Number:</label>
                                        <span>{selectedAppointment.projectNumber || 'N/A'}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="fsr-detail-section">
                                <h3>Customer Information</h3>
                                <div className="fsr-detail-grid">
                                    <div className="fsr-detail-item">
                                        <label>Customer Name:</label>
                                        <span>{selectedAppointment.customer?.customerName || 'N/A'}</span>
                                    </div>
                                    <div className="fsr-detail-item">
                                        <label>Customer Number:</label>
                                        <span>{selectedAppointment.customer?.customerNumber || 'N/A'}</span>
                                    </div>
                                    <div className="fsr-detail-item">
                                        <label>Customer Class:</label>
                                        <span>{selectedAppointment.customer?.customerClass || 'N/A'}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="fsr-detail-section">
                                <h3>Location Information</h3>
                                <div className="fsr-detail-grid">
                                    <div className="fsr-detail-item">
                                        <label>Location Name:</label>
                                        <span>{selectedAppointment.location?.locationName || 'N/A'}</span>
                                    </div>
                                    <div className="fsr-detail-item">
                                        <label>Address:</label>
                                        <span>
                                            {selectedAppointment.location?.address?.street || ''}<br/>
                                            {selectedAppointment.location?.address?.street2 && (
                                                <>{selectedAppointment.location.address.street2}<br/></>
                                            )}
                                            {selectedAppointment.location?.address?.city || ''}, {selectedAppointment.location?.address?.state || ''} {selectedAppointment.location?.address?.zip || ''}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="fsr-detail-section">
                                <h3>Contact Information</h3>
                                <div className="fsr-detail-grid">
                                    <div className="fsr-detail-item">
                                        <label>Contact Name:</label>
                                        <span>{selectedAppointment.contacts?.name || 'N/A'}</span>
                                    </div>
                                    <div className="fsr-detail-item">
                                        <label>Title:</label>
                                        <span>{selectedAppointment.contacts?.title || 'N/A'}</span>
                                    </div>
                                    <div className="fsr-detail-item">
                                        <label>Phone:</label>
                                        <span>{selectedAppointment.contacts?.number || 'N/A'}</span>
                                    </div>
                                    <div className="fsr-detail-item">
                                        <label>Email:</label>
                                        <span>{selectedAppointment.contacts?.email || 'N/A'}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="fsr-detail-section">
                                <h3>Technicians</h3>
                                <div className="fsr-detail-technicians">
                                    {selectedAppointment.technicians && selectedAppointment.technicians.length > 0 ? (
                                        selectedAppointment.technicians.map((tech, index) => (
                                            <div key={index} className="fsr-detail-tech">
                                                <span>{tech.name}</span>
                                                <span className="fsr-detail-tech-email">{tech.email}</span>
                                            </div>
                                        ))
                                    ) : (
                                        <span>No technicians assigned</span>
                                    )}
                                </div>
                            </div>

                            {Array.isArray(selectedAppointment.associatedExternal) && selectedAppointment.associatedExternal.length > 0 && (
                                <div className="fsr-detail-section">
                                    <h3>External Help</h3>
                                    <div className="fsr-external-help-list">
                                        {selectedAppointment.associatedExternal.map((external) => (
                                            <div key={external.id || `${external.name}-${external.email}`} className="fsr-external-help-tile">
                                                <div className="fsr-external-help-name">{external.name || 'N/A'}</div>
                                                <div className="fsr-external-help-company">{external.company || 'N/A'}</div>
                                                <div className="fsr-external-help-contact">{external.email || 'N/A'}</div>
                                                <div className="fsr-external-help-contact">{external.phone || 'N/A'}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            <div className="fsr-detail-section">
                                <h3>Schedule</h3>
                                <div className="fsr-detail-grid">
                                    <div className="fsr-detail-item">
                                        <label>Scheduled Start:</label>
                                        <span>{new Date(selectedAppointment.scheduledStart).toLocaleString()}</span>
                                    </div>
                                    <div className="fsr-detail-item">
                                        <label>Scheduled End:</label>
                                        <span>{new Date(selectedAppointment.scheduledEnd).toLocaleString()}</span>
                                    </div>
                                    <div className="fsr-detail-item">
                                        <label>Actual Start:</label>
                                        <span>{selectedAppointment.actualStart ? new Date(selectedAppointment.actualStart).toLocaleString() : 'N/A'}</span>
                                    </div>
                                    <div className="fsr-detail-item">
                                        <label>Actual End:</label>
                                        <span>{selectedAppointment.actualEnd ? new Date(selectedAppointment.actualEnd).toLocaleString() : 'N/A'}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="fsr-detail-section">
                                <h3>Time Tracking</h3>
                                <div className="fsr-detail-grid">
                                    <div className="fsr-detail-item">
                                        <label>Travel Time:</label>
                                        <span>{selectedAppointment.travelHours || 0}h {selectedAppointment.travelMinutes || 0}m</span>
                                    </div>
                                    <div className="fsr-detail-item">
                                        <label>Onsite Time:</label>
                                        <span>{selectedAppointment.onsiteHours || 0}h {selectedAppointment.onsiteMinutes || 0}m</span>
                                    </div>
                                </div>
                            </div>

                            {selectedAppointment.type === 'INST' && (
                                <div className="fsr-detail-section">
                                    <h3>Meetings</h3>
                                    <div className="fsr-meetings-list">
                                        <div className="fsr-meeting-row">
                                            <span className="fsr-meeting-label">OAC Meeting</span>
                                            <span className="fsr-meeting-status-box" aria-label={`OAC Meeting ${oacMeetingValue ? 'checked' : 'unchecked'}`}>
                                                {oacMeetingValue ? <span className="fsr-meeting-check">✓</span> : null}
                                            </span>
                                        </div>
                                        <div className="fsr-meeting-row">
                                            <span className="fsr-meeting-label">Safety Meeting</span>
                                            <span className="fsr-meeting-status-box" aria-label={`Safety Meeting ${safetyMeetingValue ? 'checked' : 'unchecked'}`}>
                                                {safetyMeetingValue ? <span className="fsr-meeting-check">✓</span> : null}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="fsr-detail-section">
                                <h3>Work Details</h3>
                                {selectedAppointment.troubleDescription && selectedAppointment.troubleDescription.trim() !== '' && (
                                    <div className="fsr-detail-item full-width">
                                        <label>Trouble Description:</label>
                                        <p>{selectedAppointment.troubleDescription}</p>
                                    </div>
                                )}
                                {selectedAppointment.repairDescription && selectedAppointment.repairDescription.trim() !== '' && (
                                    <div className="fsr-detail-item full-width">
                                        <label>Repair Description:</label>
                                        <p>{selectedAppointment.repairDescription}</p>
                                    </div>
                                )}
                                {selectedAppointment.techNotes && selectedAppointment.techNotes.trim() !== '' && (
                                    <div className="fsr-detail-item full-width">
                                        <label>Tech Notes:</label>
                                        <p>{selectedAppointment.techNotes}</p>
                                    </div>
                                )}
                                {selectedAppointment.officeNotes && selectedAppointment.officeNotes.trim() !== '' && (
                                    <div className="fsr-detail-item full-width">
                                        <label>Office Notes:</label>
                                        <p>{selectedAppointment.officeNotes}</p>
                                    </div>
                                )}
                                <div className="fsr-detail-item full-width fsr-additional-comments-item">
                                    <div className="fsr-additional-comments-header">
                                        <label>{selectedAppointment.type === 'INST' ? 'Daily Journal:' : 'Additional Comments:'}</label>
                                        {!editingComments && (
                                            <button
                                                className="fsr-edit-comments-btn"
                                                onClick={() => {
                                                    setCommentsEditValue(selectedAppointment.additionalComments || '');
                                                    setEditingComments(true);
                                                    setCommentsUpdateError(null);
                                                }}
                                            >
                                                Edit
                                            </button>
                                        )}
                                    </div>
                                    {editingComments ? (
                                        <div className="fsr-comments-edit-area">
                                            <textarea
                                                className="fsr-comments-textarea"
                                                value={commentsEditValue}
                                                onChange={e => setCommentsEditValue(e.target.value)}
                                                rows={4}
                                                disabled={commentsUpdateLoading}
                                            />
                                            {commentsUpdateError && (
                                                <div className="fsr-comments-error">{commentsUpdateError}</div>
                                            )}
                                            <div className="fsr-comments-actions">
                                                <button
                                                    className="fsr-comments-submit-btn"
                                                    onClick={handleUpdateAdditionalComments}
                                                    disabled={commentsUpdateLoading}
                                                >
                                                    {commentsUpdateLoading ? 'Saving...' : 'Save'}
                                                </button>
                                                <button
                                                    className="fsr-comments-cancel-btn"
                                                    onClick={() => {
                                                        setEditingComments(false);
                                                        setCommentsUpdateError(null);
                                                    }}
                                                    disabled={commentsUpdateLoading}
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    ) : (
                                        <p className={!selectedAppointment.additionalComments || selectedAppointment.additionalComments.trim() === '' ? 'fsr-comments-empty' : ''}>
                                            {selectedAppointment.additionalComments && selectedAppointment.additionalComments.trim() !== ''
                                                ? selectedAppointment.additionalComments
                                                : 'No comments added.'}
                                        </p>
                                    )}
                                </div>
                            </div>

                            <div className="fsr-detail-section">
                                <h3>FSR Information</h3>
                                <div className="fsr-detail-grid">
                                    <div className="fsr-detail-item">
                                        <label>FSR Complete:</label>
                                        <span>{selectedAppointment.fsrComplete ? 'Yes' : 'No'}</span>
                                    </div>
                                    <div className="fsr-detail-item">
                                        <label>FSR Sent:</label>
                                        <span>{selectedAppointment.fsrSent ? 'Yes' : 'No'}</span>
                                    </div>
                                    <div className="fsr-detail-item">
                                        <label>FSR Sent Date:</label>
                                        <span>{selectedAppointment.fsrSentDate ? new Date(selectedAppointment.fsrSentDate).toLocaleString() : 'N/A'}</span>
                                    </div>

                                    <div className="fsr-detail-item full-width">
                                        <label>FSR Link:</label>
                                        {selectedAppointment.fsrPath ? (
                                            <a href={selectedAppointment.fsrPath} target="_blank" rel="noopener noreferrer">
                                                View FSR
                                            </a>
                                        ) : (
                                            <span>N/A</span>
                                        )}
                                    </div>

                                    <div className="fsr-detail-item full-width">
                                        {recreateFSRError && (
                                            <div style={{ marginTop: '8px', marginBottom: '8px', color: '#dc3545' }}>
                                                {recreateFSRError}
                                            </div>
                                        )}

                                        <a
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (!recreateFSRLoading) {
                                                    handleRecreateFSR();
                                                }
                                            }}
                                            aria-disabled={recreateFSRLoading}
                                            style={recreateFSRLoading ? { pointerEvents: 'none', opacity: 0.6 } : undefined}
                                        >
                                            {recreateFSRLoading ? 'Recreating...' : 'Recreate FSR'}
                                        </a>
                                    </div>

                                    <div className="fsr-detail-item full-width">
                                        <label>File Share Link:</label>
                                        {selectedAppointment.fileShareLink ? (
                                            <a href={selectedAppointment.fileShareLink} target="_blank" rel="noopener noreferrer">
                                                View Files
                                            </a>
                                        ) : (
                                            <span>N/A</span>
                                        )}
                                    </div>

                                    {Array.isArray(selectedAppointment.attachments) && selectedAppointment.attachments.length > 0 && (
                                        <div className="fsr-detail-item full-width">
                                            <label>Attachments:</label>
                                            {attachmentDownloadError && (
                                                <div className="fsr-attachment-error">{attachmentDownloadError}</div>
                                            )}
                                            <div className="fsr-attachments-grid">
                                                {selectedAppointment.attachments.map((attachment) => {
                                                    const displayName = attachment.oldFilename || attachment.filename;
                                                    const isDownloading = attachmentDownloadLoading === attachment.filename;

                                                    return (
                                                        <button
                                                            type="button"
                                                            key={attachment.id || attachment.filename}
                                                            className="fsr-attachment-card"
                                                            onClick={() => handleDownloadAttachment(attachment)}
                                                            disabled={isDownloading}
                                                            title={displayName}
                                                        >
                                                            <span className="fsr-attachment-icon">📄</span>
                                                            <span className="fsr-attachment-name">
                                                                {isDownloading ? 'Downloading...' : displayName}
                                                            </span>
                                                            {!isDownloading && (
                                                                <span className="fsr-attachment-action">Download</span>
                                                            )}
                                                        </button>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="fsr-detail-section">
                                <h3>Additional Information</h3>
                                <div className="fsr-detail-grid">
                                    <div className="fsr-detail-item">
                                        <label>Created By:</label>
                                        <span>{selectedAppointment.createdBy || 'N/A'}</span>
                                    </div>
                                    <div className="fsr-detail-item">
                                        <label>Created Date:</label>
                                        <span>{selectedAppointment.createdDate ? new Date(selectedAppointment.createdDate).toLocaleString() : 'N/A'}</span>
                                    </div>
                                    <div className="fsr-detail-item">
                                        <label>Completed Date:</label>
                                        <span>{selectedAppointment.completedDate ? new Date(selectedAppointment.completedDate).toLocaleString() : 'N/A'}</span>
                                    </div>
                                    <div className="fsr-detail-item">
                                        <label>Linked Appointment:</label>
                                        <span>{selectedAppointment.linkedAppointment || 'N/A'}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const EquipmentListComponent = ({ 
    branchSelected, 
    apiToken,
    currentUser,
    updateEquipmentRecord: updateEquipmentProp,
    onEquipmentFormStateChange,
    refreshToken = 0
}) => {
    const [equipmentRecords, setEquipmentRecords] = useState([]);
    const [filteredRecords, setFilteredRecords] = useState([]);
    const [selectedEquipment, setSelectedEquipment] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    
    // Form mode states
    const [isCreatingNew, setIsCreatingNew] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    
    // Filter states
    const [nameFilter, setNameFilter] = useState('');
    const [customerFilter, setCustomerFilter] = useState('');
    const [locationFilter, setLocationFilter] = useState('');
    const [buildingFilter, setBuildingFilter] = useState('');
    const [floorFilter, setFloorFilter] = useState('');
    const [sectionFilter, setSectionFilter] = useState('');
    const [roomFilter, setRoomFilter] = useState('');
    const [manufacturerFilter, setManufacturerFilter] = useState('');
    const [modelFilter, setModelFilter] = useState('');
    const [categoryFilter, setCategoryFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState('');
    const [warrantyExpFromFilter, setWarrantyExpFromFilter] = useState('');
    const [warrantyExpToFilter, setWarrantyExpToFilter] = useState('');
    
    // Customer and location data for dropdowns
    const [customerAndLocations, setCustomerAndLocations] = useState([]);
    const [selectedFilterCustomer, setSelectedFilterCustomer] = useState(null);
    
    // Dropdown options extracted from records
    const [buildingOptions, setBuildingOptions] = useState([]);
    const [floorOptions, setFloorOptions] = useState([]);
    const [sectionOptions, setSectionOptions] = useState([]);
    const [roomOptions, setRoomOptions] = useState([]);
    const [manufacturerOptions, setManufacturerOptions] = useState([]);
    const [modelOptions, setModelOptions] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);

    const getBranchFilterValue = () => (
        branchSelected && branchSelected !== 'complete' ? branchSelected : undefined
    );
    
    useEffect(() => {
        // Fetch customer and location data
        fetchCustomerAndLocations(apiToken, setCustomerAndLocations, setError);
    }, [apiToken]);
    
    useEffect(() => {
        // Initial fetch of all equipment records
        handleApplyFilters();
    }, []);

    useEffect(() => {
        handleApplyFilters();
    }, [branchSelected]);

    useEffect(() => {
        if (refreshToken < 1) return;
        handleApplyFilters();
    }, [refreshToken]);
    
    useEffect(() => {
        // Extract unique values for dropdown options
        if (equipmentRecords && equipmentRecords.length > 0) {
            const buildings = [...new Set(equipmentRecords.map(e => e.building).filter(Boolean))];
            const floors = [...new Set(equipmentRecords.map(e => e.floor).filter(Boolean))];
            const sections = [...new Set(equipmentRecords.map(e => e.section).filter(Boolean))];
            const rooms = [...new Set(equipmentRecords.map(e => e.room).filter(Boolean))];
            const manufacturers = [...new Set(equipmentRecords.map(e => e.manufacturer).filter(Boolean))];
            const models = [...new Set(equipmentRecords.map(e => e.model).filter(Boolean))];
            const categories = [...new Set(equipmentRecords.map(e => e.category).filter(Boolean))];
            const statuses = [...new Set(equipmentRecords.map(e => e.status).filter(Boolean))];
            
            setBuildingOptions(buildings.sort());
            setFloorOptions(floors.sort());
            setSectionOptions(sections.sort());
            setRoomOptions(rooms.sort());
            setManufacturerOptions(manufacturers.sort());
            setModelOptions(models.sort());
            setCategoryOptions(categories.sort());
            setStatusOptions(statuses.sort());
        }
    }, [equipmentRecords]);
    
    const handleApplyFilters = async () => {
        setLoading(true);
        setError(null);
        
        const filterObject = {
            branch: getBranchFilterValue(),
            name: nameFilter || undefined,
            customer: customerFilter || undefined,
            location: locationFilter || undefined,
            building: buildingFilter || undefined,
            floor: floorFilter || undefined,
            section: sectionFilter || undefined,
            room: roomFilter || undefined,
            manufacturer: manufacturerFilter || undefined,
            model: modelFilter || undefined,
            category: categoryFilter || undefined,
            status: statusFilter || undefined,
            warrantyExpFrom: warrantyExpFromFilter || undefined,
            warrantyExpTo: warrantyExpToFilter || undefined,
        };
        
        // Remove undefined values
        Object.keys(filterObject).forEach(key => 
            filterObject[key] === undefined && delete filterObject[key]
        );
        
        await getAllEquipment(apiToken, filterObject, setEquipmentRecords, setError);
        setLoading(false);
    };
    
    const handleResetFilters = () => {
        setNameFilter('');
        setCustomerFilter('');
        setLocationFilter('');
        setBuildingFilter('');
        setFloorFilter('');
        setSectionFilter('');
        setRoomFilter('');
        setManufacturerFilter('');
        setModelFilter('');
        setCategoryFilter('');
        setStatusFilter('');
        setWarrantyExpFromFilter('');
        setWarrantyExpToFilter('');
        setSelectedFilterCustomer(null);
        
        // Reload all records
        setLoading(true);
        getAllEquipment(apiToken, { branch: getBranchFilterValue() }, setEquipmentRecords, setError);
        setLoading(false);
    };
    
    useEffect(() => {
        setFilteredRecords(equipmentRecords);
    }, [equipmentRecords]);
    
    // Form state variables
    const [name, setName] = useState('');
    const [customer, setCustomer] = useState('');
    const [location, setLocation] = useState('');
    const [building, setBuilding] = useState('');
    const [floor, setFloor] = useState('');
    const [section, setSection] = useState('');
    const [room, setRoom] = useState('');
    const [notes, setNotes] = useState('');
    const [serialNumber, setSerialNumber] = useState('');
    const [externalId, setExternalId] = useState('');
    const [manufacturer, setManufacturer] = useState('');
    const [model, setModel] = useState('');
    const [category, setCategory] = useState('');
    const [status, setStatus] = useState('active');
    const [purchaseDate, setPurchaseDate] = useState('');
    const [warrantyExpiration, setWarrantyExpiration] = useState('');
    
    const [customerSearch, setCustomerSearch] = useState('');
    const [filteredCustomers, setFilteredCustomers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
    
    const [locationSearch, setLocationSearch] = useState('');
    const [filteredLocations, setFilteredLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [showLocationDropdown, setShowLocationDropdown] = useState(false);
    
    const [existingEquipment, setExistingEquipment] = useState([]);
    const [buildingOptionsForm, setBuildingOptionsForm] = useState([]);
    const [floorOptionsForm, setFloorOptionsForm] = useState([]);
    const [sectionOptionsForm, setSectionOptionsForm] = useState([]);
    const [roomOptionsForm, setRoomOptionsForm] = useState([]);
    
    const [equipmentSuccess, setEquipmentSuccess] = useState('');
    const [equipmentError, setEquipmentError] = useState('');
    const [equipmentLoading, setEquipmentLoading] = useState(false);
    
    const getCustomerName = (customerId) => {
        const customer = customerAndLocations.find(c => c.id === customerId);
        return customer?.customerName || customerId || 'N/A';
    };
    
    const getLocationName = (customerId, locationId) => {
        const customer = customerAndLocations.find(c => c.id === customerId);
        const location = customer?.locations?.find(l => l.locationID === locationId || l.id === locationId);
        return location?.locationName || locationId || 'N/A';
    };
    
    // Form handlers
    const resetForm = () => {
        setName('');
        setCustomer('');
        setLocation('');
        setBuilding('');
        setFloor('');
        setSection('');
        setRoom('');
        setNotes('');
        setSerialNumber('');
        setExternalId('');
        setManufacturer('');
        setModel('');
        setCategory('');
        setStatus('active');
        setPurchaseDate('');
        setWarrantyExpiration('');
        setCustomerSearch('');
        setSelectedCustomer(null);
        setLocationSearch('');
        setSelectedLocation(null);
        setExistingEquipment([]);
        setBuildingOptionsForm([]);
        setFloorOptionsForm([]);
        setSectionOptionsForm([]);
        setRoomOptionsForm([]);
        setEquipmentSuccess('');
        setEquipmentError('');
    };
    
    const handleCreateNew = () => {
        resetForm();
        setIsCreatingNew(true);
        setIsEditing(false);
        setSelectedEquipment(null);
    };
    
    // Notify parent of form state changes
    useEffect(() => {
        if (onEquipmentFormStateChange) {
            onEquipmentFormStateChange({
                isCreating: isCreatingNew,
                isEditing: isEditing,
                isFormValid: isFormValid(),
                loading: equipmentLoading,
                handleSubmit,
                handleCancel,
                handleDelete,
                handleCreateNew,
                handleEdit,
                selectedEquipment
            });
        }
    }, [isCreatingNew, isEditing, name, customer, location, building, floor, section, room, 
        serialNumber, externalId, manufacturer, model, category, status, purchaseDate, 
        warrantyExpiration, notes, equipmentLoading, selectedEquipment, customerAndLocations]);
    
    const handleEdit = (equipment) => {
        setIsEditing(true);
        setIsCreatingNew(false);
        setSelectedEquipment(equipment);
        
        // Populate form with equipment data
        setName(equipment.name || '');
        setCustomer(equipment.customer || '');
        setLocation(equipment.location || '');
        setBuilding(equipment.building || '');
        setFloor(equipment.floor || '');
        setSection(equipment.section || '');
        setRoom(equipment.room || '');
        setNotes(equipment.notes || '');
        setSerialNumber(equipment.serialNumber || '');
        setExternalId(equipment.externalId || '');
        setManufacturer(equipment.manufacturer || '');
        setModel(equipment.model || '');
        setCategory(equipment.category || '');
        setStatus(equipment.status || 'active');
        setPurchaseDate(equipment.purchaseDate ? equipment.purchaseDate.substring(0, 10) : '');
        setWarrantyExpiration(equipment.warrantyExpiration ? equipment.warrantyExpiration.substring(0, 10) : '');
        
        // Set selected customer
        if (equipment.customer) {
            const foundCustomer = customerAndLocations.find(c => c.id === equipment.customer);
            if (foundCustomer) {
                setSelectedCustomer(foundCustomer);
                setCustomerSearch(foundCustomer.customerName || '');
                
                // Set selected location
                if (equipment.location) {
                    const foundLocation = foundCustomer.locations?.find(l => 
                        l.locationID === equipment.location || l.id === equipment.location
                    );
                    if (foundLocation) {
                        setSelectedLocation(foundLocation);
                        setLocationSearch(foundLocation.locationName || '');
                    }
                }
            }
        }
    };
    
    const handleCancel = () => {
        resetForm();
        setIsCreatingNew(false);
        setIsEditing(false);
        setSelectedEquipment(null);
    };
    
    const isFormValid = () => {
        return name && customer && location && building && floor && section && room;
    };
    
    const handleSubmit = () => {
        if (!isFormValid()) return;

        setEquipmentLoading(true);

        const equipmentObject = {
            name,
            customer,
            location,
            building,
            floor,
            section,
            room,
            notes,
            serialNumber,
            externalId,
            manufacturer,
            model,
            category,
            status,
            purchaseDate: purchaseDate || null,
            warrantyExpiration: warrantyExpiration || null,
            userEmail: currentUser?.email || currentUser?.userEmail || 'unknown'
        };

        if (isCreatingNew) {
            createEquipmentRecord(apiToken, equipmentObject, setEquipmentSuccess, setEquipmentError);
        } else if (isEditing) {
            equipmentObject.id = selectedEquipment.id;
            updateEquipmentRecord(apiToken, equipmentObject, setEquipmentSuccess, setEquipmentError);
        }
    };

    const handleDelete = () => {
        if (window.confirm('Are you sure you want to delete this equipment record?')) {
            setEquipmentLoading(true);
            deleteEquipmentRecord(apiToken, selectedEquipment.id, setEquipmentSuccess, setEquipmentError);
        }
    };

    useEffect(() => {
        if (equipmentSuccess) {
            setEquipmentLoading(false);
            setTimeout(() => {
                setEquipmentSuccess('');
                handleCancel();
                handleApplyFilters(); // Refresh the list
            }, 1500);
        }
    }, [equipmentSuccess]);

    useEffect(() => {
        if (equipmentError) {
            setEquipmentLoading(false);
            setTimeout(() => {
                setEquipmentError('');
            }, 4000);
        }
    }, [equipmentError]);
    
    // Fetch existing equipment for location to get dropdown options
    useEffect(() => {
        if (selectedCustomer && selectedLocation) {
            const locId = selectedLocation.locationID || selectedLocation.id;
            getCustomerLocationEquipment(apiToken, selectedCustomer.id, locId, setExistingEquipment, setEquipmentError);
        }
    }, [selectedCustomer, selectedLocation, apiToken]);

    useEffect(() => {
        // Extract unique values for dropdown options
        if (existingEquipment && existingEquipment.length > 0) {
            const buildings = [...new Set(existingEquipment.map(e => e.building).filter(Boolean))];
            const floors = [...new Set(existingEquipment.map(e => e.floor).filter(Boolean))];
            const sections = [...new Set(existingEquipment.map(e => e.section).filter(Boolean))];
            const rooms = [...new Set(existingEquipment.map(e => e.room).filter(Boolean))];
            
            setBuildingOptionsForm(buildings);
            setFloorOptionsForm(floors);
            setSectionOptionsForm(sections);
            setRoomOptionsForm(rooms);
        }
    }, [existingEquipment]);

    useEffect(() => {
        // Filter customers based on search
        if (customerSearch === '') {
            setFilteredCustomers([]);
        } else {
            const filtered = customerAndLocations.filter(c => 
                c.customerName?.toLowerCase().includes(customerSearch.toLowerCase()) ||
                c.customerNumber?.toLowerCase().includes(customerSearch.toLowerCase())
            );
            setFilteredCustomers(filtered.slice(0, 10));
        }
    }, [customerSearch, customerAndLocations]);

    useEffect(() => {
        // Filter locations based on selected customer and search
        if (selectedCustomer && locationSearch) {
            const filtered = selectedCustomer.locations?.filter(l =>
                l.locationName?.toLowerCase().includes(locationSearch.toLowerCase()) ||
                l.locationID?.toString().toLowerCase().includes(locationSearch.toLowerCase())
            ) || [];
            setFilteredLocations(filtered.slice(0, 10));
        } else if (selectedCustomer) {
            setFilteredLocations(selectedCustomer.locations || []);
        } else {
            setFilteredLocations([]);
        }
    }, [locationSearch, selectedCustomer]);

    const handleSelectCustomer = (cust) => {
        setSelectedCustomer(cust);
        setCustomer(cust.id);
        setCustomerSearch(cust.customerName || '');
        setShowCustomerDropdown(false);
        
        // Reset location when customer changes
        setSelectedLocation(null);
        setLocation('');
        setLocationSearch('');
    };

    const handleSelectLocation = (loc) => {
        setSelectedLocation(loc);
        setLocation(loc.locationID || loc.id);
        setLocationSearch(loc.locationName || '');
        setShowLocationDropdown(false);
    };
    
    return (
        <div className="equipment-list-container">
            {/* Top Toolbar */}
            <div className="equipment-list-toolbar">
                <div className="equipment-list-filters">
                    <div className="equipment-filter-group">
                        <label>Name</label>
                        <input
                            type="text"
                            value={nameFilter}
                            onChange={(e) => setNameFilter(e.target.value)}
                            className="equipment-filter-input"
                            placeholder="Search by name"
                        />
                    </div>
                    
                    <div className="equipment-filter-group">
                        <label>Customer</label>
                        <select
                            value={customerFilter}
                            onChange={(e) => {
                                const customerId = e.target.value;
                                setCustomerFilter(customerId);
                                const customer = customerAndLocations.find(c => String(c.id) === String(customerId));
                                setSelectedFilterCustomer(customer || null);
                                setLocationFilter(''); // Reset location when customer changes
                            }}
                            className="equipment-filter-select"
                        >
                            <option value="">All Customers</option>
                            {customerAndLocations.map((c) => (
                                <option key={c.id} value={c.id}>
                                    {c.customerName} ({c.customerNumber})
                                </option>
                            ))}
                        </select>
                    </div>
                    
                    <div className="equipment-filter-group">
                        <label>Location</label>
                        <select
                            value={locationFilter}
                            onChange={(e) => setLocationFilter(e.target.value)}
                            className="equipment-filter-select"
                            disabled={!selectedFilterCustomer}
                        >
                            <option value="">All Locations</option>
                            {selectedFilterCustomer?.locations?.map((l) => (
                                <option key={l.locationID || l.id} value={l.locationID || l.id}>
                                    {l.locationName} ({l.locationID || l.id})
                                </option>
                            ))}
                        </select>
                    </div>
                    
                    <div className="equipment-filter-group">
                        <label>Building</label>
                        <select
                            value={buildingFilter}
                            onChange={(e) => setBuildingFilter(e.target.value)}
                            className="equipment-filter-select"
                        >
                            <option value="">All Buildings</option>
                            {buildingOptions.map((b) => (
                                <option key={b} value={b}>{b}</option>
                            ))}
                        </select>
                    </div>
                    
                    <div className="equipment-filter-group">
                        <label>Floor</label>
                        <select
                            value={floorFilter}
                            onChange={(e) => setFloorFilter(e.target.value)}
                            className="equipment-filter-select"
                        >
                            <option value="">All Floors</option>
                            {floorOptions.map((f) => (
                                <option key={f} value={f}>{f}</option>
                            ))}
                        </select>
                    </div>
                    
                    <div className="equipment-filter-group">
                        <label>Section</label>
                        <select
                            value={sectionFilter}
                            onChange={(e) => setSectionFilter(e.target.value)}
                            className="equipment-filter-select"
                        >
                            <option value="">All Sections</option>
                            {sectionOptions.map((s) => (
                                <option key={s} value={s}>{s}</option>
                            ))}
                        </select>
                    </div> 
                    
                    <div className="equipment-filter-group">
                        <label>Room</label>
                        <select
                            value={roomFilter}
                            onChange={(e) => setRoomFilter(e.target.value)}
                            className="equipment-filter-select"
                        >
                            <option value="">All Rooms</option>
                            {roomOptions.map((r) => (
                                <option key={r} value={r}>{r}</option>
                            ))}
                        </select>
                    </div>
                    
                    <div className="equipment-filter-group">
                        <label>Category</label>
                        <select
                            value={categoryFilter}
                            onChange={(e) => setCategoryFilter(e.target.value)}
                            className="equipment-filter-select"
                        >
                            <option value="">All Categories</option>
                            {equipmentTypeOptions.map((c) => (
                                <option key={c} value={c}>{c}</option>
                            ))}
                        </select>
                    </div>
                    
                    <div className="equipment-filter-group">
                        <label>Status</label>
                        <select
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                            className="equipment-filter-select"
                        >
                            <option value="">All Statuses</option>
                            {statusOptions.map((s) => (
                                <option key={s} value={s}>{s}</option>
                            ))}
                        </select>
                    </div>
                    
                    <div className="equipment-filter-group">
                        <label>Warranty From</label>
                        <input
                            type="date"
                            value={warrantyExpFromFilter}
                            onChange={(e) => setWarrantyExpFromFilter(e.target.value)}
                            className="equipment-filter-input"
                        />
                    </div>
                    
                    <div className="equipment-filter-group">
                        <label>Warranty To</label>
                        <input
                            type="date"
                            value={warrantyExpToFilter}
                            onChange={(e) => setWarrantyExpToFilter(e.target.value)}
                            className="equipment-filter-input"
                        />
                    </div>
                </div>
                
                <div className="equipment-filter-actions">
                    <button
                        onClick={handleApplyFilters}
                        className="equipment-filter-button primary"
                        disabled={loading}
                    >
                        Apply Filters
                    </button>
                    <button
                        onClick={handleResetFilters}
                        className="equipment-filter-button secondary"
                        disabled={loading}
                    >
                        Reset
                    </button>
                </div>
            </div>
            
            {/* Main Content Area */}
            <div className="equipment-list-content">
                {/* Left Sidebar - Equipment List */}
                <div className="equipment-list-sidebar">
                    {loading && (
                        <div className="equipment-list-loading">Loading equipment records...</div>
                    )}
                    {error && (
                        <div className="equipment-list-error">{error}</div>
                    )}
                    {!loading && filteredRecords.length === 0 && (
                        <div className="equipment-list-empty">No equipment records found</div>
                    )}
                    {!loading && filteredRecords.length > 0 && (
                        <div className="equipment-record-tiles">
                            {filteredRecords.map((record) => (
                                <div
                                    key={record.id}
                                    className={`equipment-record-tile ${selectedEquipment?.id === record.id ? 'selected' : ''}`}
                                    onClick={() => setSelectedEquipment(record)}
                                >
                                    <div className="equipment-tile-header">
                                        <span className="equipment-tile-name">{record.name}</span>
                                        <span className={`equipment-tile-status ${record.status}`}>
                                            {record.status}
                                        </span>
                                    </div>
                                    <div className="equipment-tile-location">
                                        {record.building && `${record.building} - `}
                                        {record.floor && `Floor ${record.floor} - `}
                                        {record.section && `${record.section} - `}
                                        {record.room && `Room ${record.room}`}
                                    </div>
                                    <div className="equipment-tile-customer">
                                        {getCustomerName(record.customer)} - {getLocationName(record.customer, record.location)}
                                    </div>
                                    <div className="equipment-tile-details">
                                        {record.manufacturer && `${record.manufacturer} `}
                                        {record.model && `${record.model}`}
                                    </div>
                                    {record.serialNumber && (
                                        <div className="equipment-tile-serial">
                                            S/N: {record.serialNumber}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                
                {/* Right Panel - Equipment Details or Form */}
                <div className="equipment-detail-panel">
                    {(isCreatingNew || isEditing) ? (
                        <div className="equipment-detail-content">
                            <div className="equipment-detail-title-bar">
                                <h2 className="equipment-detail-title">
                                    {isCreatingNew ? 'New Equipment Record' : 'Edit Equipment Record'}
                                </h2>
                            </div>
                            
                            {equipmentSuccess && (
                                <div className="equipment-success-message">{equipmentSuccess}</div>
                            )}
                            {equipmentError && (
                                <div className="equipment-error-message">{equipmentError}</div>
                            )}
                            
                            <div className="equipment-form">
                                <div className="equipment-detail-section">
                                    <h3>Basic Information</h3>
                                    <div className="equipment-detail-grid">
                                        <div className="equipment-form-group">
                                            <label>Name *</label>
                                            <input
                                                type="text"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                className="equipment-input"
                                                placeholder="Equipment name"
                                            />
                                        </div>
                                        
                                        <div className="equipment-form-group">
                                            <label>Serial Number</label>
                                            <input
                                                type="text"
                                                value={serialNumber}
                                                onChange={(e) => setSerialNumber(e.target.value)}
                                                className="equipment-input"
                                                placeholder="Serial number"
                                            />
                                        </div>
                                        
                                        <div className="equipment-form-group">
                                            <label>External ID</label>
                                            <input
                                                type="text"
                                                value={externalId}
                                                onChange={(e) => setExternalId(e.target.value)}
                                                className="equipment-input"
                                                placeholder="External ID"
                                            />
                                        </div>
                                        
                                        <div className="equipment-form-group">
                                            <label>Status *</label>
                                            <select
                                                value={status}
                                                onChange={(e) => setStatus(e.target.value)}
                                                className="equipment-input"
                                            >
                                                <option value="active">Active</option>
                                                <option value="inactive">Inactive</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="equipment-detail-section">
                                    <h3>Customer & Location</h3>
                                    <div className="equipment-detail-grid">
                                        <div className="equipment-form-group">
                                            <label>Customer *</label>
                                            <div className="equipment-dropdown-container">
                                                <input
                                                    type="text"
                                                    value={customerSearch}
                                                    onChange={(e) => {
                                                        setCustomerSearch(e.target.value);
                                                        setShowCustomerDropdown(true);
                                                    }}
                                                    onFocus={() => setShowCustomerDropdown(true)}
                                                    className="equipment-input"
                                                    placeholder="Search customer"
                                                />
                                                {showCustomerDropdown && filteredCustomers.length > 0 && (
                                                    <div className="equipment-dropdown">
                                                        {filteredCustomers.map((cust) => (
                                                            <div
                                                                key={cust.id}
                                                                className="equipment-dropdown-item"
                                                                onClick={() => handleSelectCustomer(cust)}
                                                            >
                                                                {cust.customerName} ({cust.customerNumber})
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        
                                        <div className="equipment-form-group">
                                            <label>Location *</label>
                                            <div className="equipment-dropdown-container">
                                                <input
                                                    type="text"
                                                    value={locationSearch}
                                                    onChange={(e) => {
                                                        setLocationSearch(e.target.value);
                                                        setShowLocationDropdown(true);
                                                    }}
                                                    onFocus={() => setShowLocationDropdown(true)}
                                                    className="equipment-input"
                                                    placeholder="Search location"
                                                    disabled={!selectedCustomer}
                                                />
                                                {showLocationDropdown && filteredLocations.length > 0 && (
                                                    <div className="equipment-dropdown">
                                                        {filteredLocations.map((loc) => (
                                                            <div
                                                                key={loc.locationID}
                                                                className="equipment-dropdown-item"
                                                                onClick={() => handleSelectLocation(loc)}
                                                            >
                                                                {loc.locationName} ({loc.locationID})
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="equipment-detail-section">
                                    <h3>Location Details</h3>
                                    <div className="equipment-detail-grid">
                                        <div className="equipment-form-group">
                                            <label>Building *</label>
                                            <input
                                                type="text"
                                                value={building}
                                                onChange={(e) => setBuilding(e.target.value)}
                                                className="equipment-input"
                                                placeholder="Building"
                                                list="building-options-form"
                                            />
                                            <datalist id="building-options-form">
                                                {buildingOptionsForm.map((opt, idx) => (
                                                    <option key={idx} value={opt} />
                                                ))}
                                            </datalist>
                                        </div>
                                        
                                        <div className="equipment-form-group">
                                            <label>Floor *</label>
                                            <input
                                                type="text"
                                                value={floor}
                                                onChange={(e) => setFloor(e.target.value)}
                                                className="equipment-input"
                                                placeholder="Floor"
                                                list="floor-options-form"
                                            />
                                            <datalist id="floor-options-form">
                                                {floorOptionsForm.map((opt, idx) => (
                                                    <option key={idx} value={opt} />
                                                ))}
                                            </datalist>
                                        </div>
                                        
                                        <div className="equipment-form-group">
                                            <label>Section *</label>
                                            <input
                                                type="text"
                                                value={section}
                                                onChange={(e) => setSection(e.target.value)}
                                                className="equipment-input"
                                                placeholder="Section"
                                                list="section-options-form"
                                            />
                                            <datalist id="section-options-form">
                                                {sectionOptionsForm.map((opt, idx) => (
                                                    <option key={idx} value={opt} />
                                                ))}
                                            </datalist>
                                        </div>
                                        
                                        <div className="equipment-form-group">
                                            <label>Room *</label>
                                            <input
                                                type="text"
                                                value={room}
                                                onChange={(e) => setRoom(e.target.value)}
                                                className="equipment-input"
                                                placeholder="Room"
                                                list="room-options-form"
                                            />
                                            <datalist id="room-options-form">
                                                {roomOptionsForm.map((opt, idx) => (
                                                    <option key={idx} value={opt} />
                                                ))}
                                            </datalist>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="equipment-detail-section">
                                    <h3>Equipment Details</h3>
                                    <div className="equipment-detail-grid">
                                        <div className="equipment-form-group">
                                            <label>Manufacturer</label>
                                            <input
                                                type="text"
                                                value={manufacturer}
                                                onChange={(e) => setManufacturer(e.target.value)}
                                                className="equipment-input"
                                                placeholder="Manufacturer"
                                            />
                                        </div>
                                        
                                        <div className="equipment-form-group">
                                            <label>Model</label>
                                            <input
                                                type="text"
                                                value={model}
                                                onChange={(e) => setModel(e.target.value)}
                                                className="equipment-input"
                                                placeholder="Model"
                                            />
                                        </div>
                                        
                                        <div className="equipment-form-group">
                                            <label>Category</label>
                                            <select
                                                value={category}
                                                onChange={(e) => setCategory(e.target.value)}
                                                className="equipment-input"
                                            >
                                                <option value="">Select Category</option>
                                                {equipmentTypeOptions.map((c) => (
                                                    <option key={c} value={c}>{c}</option>
                                                ))}
                                            </select>
                                        </div>
                                        
                                        <div className="equipment-form-group">
                                            <label>Purchase Date</label>
                                            <input
                                                type="date"
                                                value={purchaseDate}
                                                onChange={(e) => setPurchaseDate(e.target.value)}
                                                className="equipment-input"
                                            />
                                        </div>
                                        
                                        <div className="equipment-form-group">
                                            <label>Warranty Expiration</label>
                                            <input
                                                type="date"
                                                value={warrantyExpiration}
                                                onChange={(e) => setWarrantyExpiration(e.target.value)}
                                                className="equipment-input"
                                            />
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="equipment-detail-section">
                                    <h3>Notes</h3>
                                    <div className="equipment-form-group full-width">
                                        <textarea
                                            value={notes}
                                            onChange={(e) => setNotes(e.target.value)}
                                            className="equipment-textarea"
                                            placeholder="Additional notes"
                                            rows={4}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : !selectedEquipment ? (
                        <div className="equipment-detail-empty">
                            <div className="equipment-detail-empty-content">
                                <p>Select an equipment record to view details or click "New Equipment" to create one</p>
                            </div>
                        </div>
                    ) : (
                        <div className="equipment-detail-content">
                            <div className="equipment-detail-title-bar">
                                <h2 className="equipment-detail-title">Equipment Details</h2>
                            </div>
                            
                            <div className="equipment-detail-section">
                                <h3>Basic Information</h3>
                                <div className="equipment-detail-grid">
                                    <div className="equipment-detail-item">
                                        <label>Name:</label>
                                        <span>{selectedEquipment.name || 'N/A'}</span>
                                    </div>
                                    <div className="equipment-detail-item">
                                        <label>Status:</label>
                                        <span className={`equipment-status-badge ${selectedEquipment.status}`}>
                                            {selectedEquipment.status || 'N/A'}
                                        </span>
                                    </div>
                                    <div className="equipment-detail-item">
                                        <label>Serial Number:</label>
                                        <span>{selectedEquipment.serialNumber || 'N/A'}</span>
                                    </div>
                                    <div className="equipment-detail-item">
                                        <label>External ID:</label>
                                        <span>{selectedEquipment.externalId || 'N/A'}</span>
                                    </div>
                                    <div className="equipment-detail-item">
                                        <label>Category:</label>
                                        <span>{selectedEquipment.category || 'N/A'}</span>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="equipment-detail-section">
                                <h3>Customer & Location</h3>
                                <div className="equipment-detail-grid">
                                    <div className="equipment-detail-item">
                                        <label>Customer:</label>
                                        <span>{getCustomerName(selectedEquipment.customer)}</span>
                                    </div>
                                    <div className="equipment-detail-item">
                                        <label>Location:</label>
                                        <span>{getLocationName(selectedEquipment.customer, selectedEquipment.location)}</span>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="equipment-detail-section">
                                <h3>Location Details</h3>
                                <div className="equipment-detail-grid">
                                    <div className="equipment-detail-item">
                                        <label>Building:</label>
                                        <span>{selectedEquipment.building || 'N/A'}</span>
                                    </div>
                                    <div className="equipment-detail-item">
                                        <label>Floor:</label>
                                        <span>{selectedEquipment.floor || 'N/A'}</span>
                                    </div>
                                    <div className="equipment-detail-item">
                                        <label>Section:</label>
                                        <span>{selectedEquipment.section || 'N/A'}</span>
                                    </div>
                                    <div className="equipment-detail-item">
                                        <label>Room:</label>
                                        <span>{selectedEquipment.room || 'N/A'}</span>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="equipment-detail-section">
                                <h3>Equipment Details</h3>
                                <div className="equipment-detail-grid">
                                    <div className="equipment-detail-item">
                                        <label>Manufacturer:</label>
                                        <span>{selectedEquipment.manufacturer || 'N/A'}</span>
                                    </div>
                                    <div className="equipment-detail-item">
                                        <label>Model:</label>
                                        <span>{selectedEquipment.model || 'N/A'}</span>
                                    </div>
                                    <div className="equipment-detail-item">
                                        <label>Purchase Date:</label>
                                        <span>
                                            {selectedEquipment.purchaseDate
                                                ? new Date(selectedEquipment.purchaseDate).toLocaleDateString()
                                                : 'N/A'}
                                        </span>
                                    </div>
                                    <div className="equipment-detail-item">
                                        <label>Warranty Expiration:</label>
                                        <span>
                                            {selectedEquipment.warrantyExpiration
                                                ? new Date(selectedEquipment.warrantyExpiration).toLocaleDateString()
                                                : 'N/A'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                            {selectedEquipment.notes && (
                                <div className="equipment-detail-section">
                                    <h3>Notes</h3>
                                    <div className="equipment-detail-item full-width">
                                        <p>{selectedEquipment.notes}</p>
                                    </div>
                                </div>
                            )}
                            
                            <div className="equipment-detail-section">
                                <h3>Additional Information</h3>
                                <div className="equipment-detail-grid">
                                    <div className="equipment-detail-item">
                                        <label>Created By:</label>
                                        <span>{selectedEquipment.createdBy || 'N/A'}</span>
                                    </div>
                                    <div className="equipment-detail-item">
                                        <label>Created Date:</label>
                                        <span>
                                            {selectedEquipment.createdDate
                                                ? new Date(selectedEquipment.createdDate).toLocaleString()
                                                : 'N/A'}
                                        </span>
                                    </div>
                                    <div className="equipment-detail-item">
                                        <label>Last Updated By:</label>
                                        <span>{selectedEquipment.updatedBy || 'N/A'}</span>
                                    </div>
                                    <div className="equipment-detail-item">
                                        <label>Last Updated Date:</label>
                                        <span>
                                            {selectedEquipment.lastUpdatedDate
                                                ? new Date(selectedEquipment.lastUpdatedDate).toLocaleString()
                                                : 'N/A'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

// Primary Application
const FieldService = () => {
    const contextObject = useContext(Context);
    const [moduleSelected, setModuleSelected] = useState('Calendar');
    
    // Initialize branch selection from localStorage or default to 'complete'
    const [branchSelected, setBranchSelected] = useState(() => {
        const savedBranch = localStorage.getItem('fieldService-branchSelected');
        return savedBranch || 'complete';
    });

    // New or Edit
    const [appointmentType, setAppointmentType] = useState('');
    const [appointmentLoading, setAppointmentLoading] = useState(false);
    const [appointmentSuccess, setAppointmentSuccess] = useState('');
    const [appointmentError, setAppointmentError] = useState('');
    const [existingAppointmentObject, setExistingAppointmentObject] = useState(null);
    const [isReadOnlyAppointment, setIsReadOnlyAppointment] = useState(false);

    const [editFSR, setEditFSR] = useState(false);
    const [editAppointment, setEditAppointment] = useState(false);
    const [editEquipment, setEditEquipment] = useState(false);
    
    const [equipmentType, setEquipmentType] = useState('');
    const [existingEquipmentObject, setExistingEquipmentObject] = useState(null);
    
    // Equipment form state passed from EquipmentListComponent
    const [equipmentFormState, setEquipmentFormState] = useState({
        isCreating: false,
        isEditing: false,
        isFormValid: false,
        loading: false,
        handleSubmit: null,
        handleCancel: null,
        handleDelete: null,
        handleCreateNew: null,
        handleEdit: null,
        selectedEquipment: null
    });

    const [technicians, setTechnicians] = useState([]);
    const [filteredTechnicians, setFilteredTechnicians] = useState([]);
    const [techniciansError, setTechniciansError] = useState(null);

    const [appointments, setAppointments] = useState({});
    const [filteredAppointments, setFilteredAppointments] = useState(appointments);
    const [appointmentsError, setAppointmentsError] = useState(null);
    const [reportsRefreshToken, setReportsRefreshToken] = useState(0);
    const [equipmentRefreshToken, setEquipmentRefreshToken] = useState(0);


    const submitAppointment = (appointmentData) => {
        if (isReadOnlyAppointment) return;
        // Logic to submit appointment goes here
        setAppointmentLoading(true);
        if(appointmentType === 'New') createFSAppointment(contextObject.apiToken, appointmentData, setAppointmentSuccess, setAppointmentError);
        if(appointmentType === 'Edit') updateFSAppointment(contextObject.apiToken, appointmentData, setAppointmentSuccess, setAppointmentError);
    };

    useEffect(() => {
        if (appointmentSuccess) {
            setAppointmentLoading(false);
            setTimeout(() => {
                setAppointmentSuccess('');
                setEditAppointment(false);
            }, 2000);

            getAppointments();
        }
    }, [appointmentSuccess]);

    useEffect(() => {
        if (appointmentError) {
            setAppointmentLoading(false);
            setTimeout(() => {
                setAppointmentError('');
                setEditAppointment(false);
            }, 4000);
        }
    }, [appointmentError]);

    const createAppointment = () => {
        setIsReadOnlyAppointment(false);
        setEditAppointment(true);
        setAppointmentType('New');
    };

    const updateAppointment = (appointmentId, readOnly = false) => {
        getAppointmentById(contextObject.apiToken, appointmentId, setExistingAppointmentObject, setAppointmentError);
        setIsReadOnlyAppointment(readOnly);
        setEditAppointment(true);
        setAppointmentType('Edit');
    };

    const rescheduleAppointment = async (appointment, targetDate) => {
        try {
            if (!contextObject.apiToken || !appointment) return;

            const appointmentIdentifier = appointment.appointmentNbr || appointment.appointmentID;
            if (!appointmentIdentifier) return;

            const formattedNewStartDate = new Date(targetDate).toISOString().split('T')[0];
            await changeFSAppointmentDate(
                contextObject.apiToken,
                appointmentIdentifier,
                formattedNewStartDate,
                () => {},
                setAppointmentError
            );
            await getAppointments();
        } catch (error) {
            console.error('Error rescheduling appointment:', error);
            setAppointmentError('Failed to reschedule appointment. Please try again.');
        }
    };

    const createFSR = () => {
        setEditFSR(true);
    };

    const changeModule = (module) => {
        setModuleSelected(module);
        setEditAppointment(false);
        setIsReadOnlyAppointment(false);
        setEditFSR(false);
        setEditEquipment(false);
    };

    const refreshModuleResults = () => {
        if (moduleSelected === 'Calendar') {
            getTechnicians();
            getAppointments();
            return;
        }

        if (moduleSelected === 'Reports') {
            setReportsRefreshToken((prev) => prev + 1);
            return;
        }

        if (moduleSelected === 'Equipment') {
            setEquipmentRefreshToken((prev) => prev + 1);
        }
    };

    const createEquipment = () => {
        // Call handleCreateNew from EquipmentListComponent if available
        if (equipmentFormState.handleCreateNew) {
            equipmentFormState.handleCreateNew();
        }
    };
    
    const updateEquipmentRecord = (equipmentId) => {
        // Fetch equipment by ID and open edit modal
        // For now, we'll need to add this functionality to get equipment by ID
        setEditEquipment(true);
        setEquipmentType('Edit');
        // setExistingEquipmentObject will be set when we have the equipment record
    };
    
    const refreshEquipment = () => {
        // This will be called after creating/updating equipment to refresh the list
        // The EquipmentListComponent will handle its own refresh
    };

    const getTechnicians = async () => {
        getAllServiceTechnicians(contextObject.apiToken, setTechnicians, setTechniciansError);
    };

    const getAppointments = async () => {
        getAllAppointments(contextObject.apiToken, branchSelected, setAppointments, setAppointmentsError);
    };

    useEffect(() => {
        getTechnicians();
    }, []);

    useEffect(() => {
        if (!contextObject.apiToken) return;
        getAppointments();
    }, [branchSelected, contextObject.apiToken]);

    // Save branch selection to localStorage whenever it changes
    useEffect(() => {
        localStorage.setItem('fieldService-branchSelected', branchSelected);
    }, [branchSelected]);

    useEffect(() => {
        if (branchSelected === 'complete') {
            setFilteredTechnicians(technicians);
        } else {
            // Filter technicians by branch - technicians is now an array
            const filtered = (technicians || []).filter(tech => 
                tech.branch === branchSelected
            );
            setFilteredTechnicians(filtered);
        }
    }, [technicians, branchSelected]);

    useEffect(() => {
        setFilteredAppointments(appointments);
    }, [appointments, branchSelected]);

    const headerProps = {
        moduleSelected,
        changeModule,
        createAppointment,
        createFSR,
        branchSelected,
        setBranchSelected,
        editEquipment,
        setEditEquipment,
        createEquipment,
        // Equipment form state
        isCreatingEquipment: equipmentFormState.isCreating,
        isEditingEquipment: equipmentFormState.isEditing,
        isEquipmentFormValid: equipmentFormState.isFormValid,
        equipmentLoading: equipmentFormState.loading,
        handleEquipmentSubmit: equipmentFormState.handleSubmit,
        handleEquipmentCancel: equipmentFormState.handleCancel,
        handleEquipmentDelete: equipmentFormState.handleDelete,
        selectedEquipment: equipmentFormState.selectedEquipment,
        handleEquipmentEdit: () => {
            if (equipmentFormState.handleEdit && equipmentFormState.selectedEquipment) {
                equipmentFormState.handleEdit(equipmentFormState.selectedEquipment);
            }
        },
        handleEquipmentClose: () => {
            if (equipmentFormState.selectedEquipment) {
                // Clear selection in EquipmentListComponent
                equipmentFormState.handleCancel();
            }
        },
        refreshModuleResults,
    };

    const appointmentProps = {
        onClose: () => {setEditAppointment(false); setExistingAppointmentObject(null); setIsReadOnlyAppointment(false);},
        branchSelected,
        setBranchSelected,
        filteredTechnicians,
        apiToken:contextObject.apiToken,
        submitAppointment,
        appointmentLoading,
        appointmentSuccess,
        appointmentError,
        currentUser:contextObject.activeUser,
        appointmentType,
        existingAppointmentObject,
        setExistingAppointmentObject,
        refreshAppointments: getAppointments,
        isReadOnly: isReadOnlyAppointment,
    };

    const calendarProps = {
        filteredTechnicians,
        branchSelected,
        filteredAppointments,
        updateAppointment,
        rescheduleAppointment,
        currentUserBranch: contextObject.activeUser?.branch,
    };

    const fsrProps = {
        onClose: () => setEditFSR(false)
    };

    const equipmentProps = {
        onClose: () => {
            setEditEquipment(false);
            setExistingEquipmentObject(null);
        },
        apiToken: contextObject.apiToken,
        currentUser: contextObject.activeUser,
        equipmentType,
        existingEquipmentObject,
        setExistingEquipmentObject,
        refreshEquipment,
    };

    return(
        <div className='field-service-container'>
            <FieldServiceHeader {...headerProps}/>
            {
                editAppointment ?
                <AppointmentComponent {...appointmentProps}/> : <></>
            }
            {            
                editFSR ?
                <FSRComponent {...fsrProps}/> : <></>
            }
            {   moduleSelected === 'Calendar' ? 
                <CalendarComponent {...calendarProps} /> : <></>
            }        
            {   moduleSelected === 'Reports' ? 
                <FSRListComponent branchSelected={branchSelected} refreshToken={reportsRefreshToken} /> : <></>
            }
            {   moduleSelected === 'Equipment' ? 
                <EquipmentListComponent 
                    branchSelected={branchSelected}
                    apiToken={contextObject.apiToken}
                    currentUser={contextObject.activeUser}
                    updateEquipmentRecord={updateEquipmentRecord}
                    onEquipmentFormStateChange={setEquipmentFormState}
                    refreshToken={equipmentRefreshToken}
                /> : <></>
            }
        </div>

    )
};

export default FieldService;